import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { facturasAPI, productosServiciosAPI, tiposImpositivosAPI, clientesAPI, pagosAPI, presupuestosAPI, facturacionStatsAPI, recordatoriosAPI, emailAPI, codigosDescuentoAPI, descuentosVolumenAPI, facturasRecurrentesAPI, authAPI, usuariosAPI, pagosUsuariosAPI, consultasAPI, getSecureFileUrl } from '../services/api';
import './Facturacion.css';

const ESTADOS = ['borrador', 'enviada', 'pagada', 'parcial', 'cancelada'];
const ESTADOS_PRESUPUESTO = ['borrador', 'enviado', 'aceptado', 'rechazado', 'convertido'];
const UNIDADES = ['ud', 'sesión', 'hora', 'día'];
const METODOS_PAGO = ['transferencia', 'efectivo', 'tarjeta', 'PayPal', 'bizum', 'otro'];
const FRECUENCIAS_REC = [
  { value: 'mensual', label: 'Mensual' },
  { value: 'trimestral', label: 'Trimestral' },
  { value: 'semestral', label: 'Semestral' },
  { value: 'anual', label: 'Anual' },
];

// Helper para calcular fecha + 14 días
const getFechaVencimientoDefault = () => {
  const fecha = new Date();
  fecha.setDate(fecha.getDate() + 14);
  return fecha.toISOString().slice(0, 10);
};

function Facturacion() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState('dashboard');
  const [view, setView] = useState('list');
  const [facturas, setFacturas] = useState([]);
  const [productos, setProductos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedFactura, setSelectedFactura] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [filtroEstado, setFiltroEstado] = useState('');
  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroBusqueda, setFiltroBusqueda] = useState('');
  const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
  const [filtroFechaHasta, setFiltroFechaHasta] = useState('');

  const [consultas, setConsultas] = useState([]);
  const [form, setForm] = useState({
    cliente_id: '',
    serie: 'A',
    fecha_emision: new Date().toISOString().slice(0, 10),
    fecha_vencimiento: getFechaVencimientoDefault(),
    retencion_irpf_pct: 0,
    notas: '',
    notas_internas: '',
    codigo_descuento: '',
    consulta_id: '',
    lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
  });
  const [formProducto, setFormProducto] = useState({ nombre: '', descripcion: '', precio_unitario: 0, unidad: 'sesión', tipo: 'servicio', iva_pct: 21 });
  const [editingProducto, setEditingProducto] = useState(null);
  const [showProductoForm, setShowProductoForm] = useState(false);

  const [facturaPagos, setFacturaPagos] = useState([]);
  const [totalPagado, setTotalPagado] = useState(0);
  const [showPagoForm, setShowPagoForm] = useState(false);
  const [formPago, setFormPago] = useState({ fecha: new Date().toISOString().slice(0, 10), importe: '', metodo: 'transferencia', referencia: '', notas: '' });
  const [transacciones, setTransacciones] = useState([]);
  const [kpisCobros, setKpisCobros] = useState({ cobrado_hoy: 0, cobrado_mes: 0, tasa_exito_cobro: 0 });
  const [filtroTransEstado, setFiltroTransEstado] = useState('');
  const [filtroTransCliente, setFiltroTransCliente] = useState('');
  const [filtroTransFechaDesde, setFiltroTransFechaDesde] = useState('');
  const [filtroTransFechaHasta, setFiltroTransFechaHasta] = useState('');
  const [filtroTransBusqueda, setFiltroTransBusqueda] = useState('');
  
  // Email
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailTipo, setEmailTipo] = useState(''); // 'factura' o 'presupuesto'
  const [emailId, setEmailId] = useState(null);
  const [formEmail, setFormEmail] = useState({ email: '', mensaje: '' });

  // Presupuestos
  const [presupuestos, setPresupuestos] = useState([]);
  const [selectedPresupuesto, setSelectedPresupuesto] = useState(null);
  const [presView, setPresView] = useState('list'); // list | detail | form
  const [filtroPresEstado, setFiltroPresEstado] = useState('');
  const [filtroPresCliente, setFiltroPresCliente] = useState('');
  const [presForm, setPresForm] = useState({
    cliente_id: '',
    serie: 'A',
    fecha_emision: new Date().toISOString().slice(0, 10),
    fecha_validez: getFechaVencimientoDefault(),
    retencion_irpf_pct: 0,
    notas: '',
    notas_internas: '',
    codigo_descuento: '',
    lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
  });

  // Dashboard/Estadísticas
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(false);
  const [recordatorios, setRecordatorios] = useState(null);

  // Selección para descargar varias facturas en ZIP
  const [facturasSeleccionadas, setFacturasSeleccionadas] = useState(new Set());

  // Promociones: códigos de descuento y descuentos por volumen
  const [codigosDescuento, setCodigosDescuento] = useState([]);
  const [descuentosVolumen, setDescuentosVolumen] = useState([]);
  const [promoLoading, setPromoLoading] = useState(false);
  const [showCodigoForm, setShowCodigoForm] = useState(false);
  const [showVolumenForm, setShowVolumenForm] = useState(false);
  const [formCodigo, setFormCodigo] = useState({ codigo: '', nombre: '', tipo: 'porcentaje', valor: 0, fecha_desde: '', fecha_hasta: '', minimo_importe: 0, max_usos: '', activo: 1 });
  const [formVolumen, setFormVolumen] = useState({ nombre: '', min_importe: 0, descuento_pct: 0, activo: 1 });
  const [editingCodigoId, setEditingCodigoId] = useState(null);
  const [editingVolumenId, setEditingVolumenId] = useState(null);

  // Tipos impositivos (IVA, etc.)
  const [tiposImpositivos, setTiposImpositivos] = useState([]);
  const [showTipoImpositivoForm, setShowTipoImpositivoForm] = useState(false);
  const [editingTipoImpositivo, setEditingTipoImpositivo] = useState(null);
  const [formTipoImpositivo, setFormTipoImpositivo] = useState({ nombre: '', porcentaje: 21, orden: 0 });

  // Facturas recurrentes
  const [facturasRecurrentes, setFacturasRecurrentes] = useState([]);
  const [recView, setRecView] = useState('list'); // list | form | detail
  const [selectedRecurrente, setSelectedRecurrente] = useState(null);
  const [recForm, setRecForm] = useState({
    cliente_id: '',
    nombre: '',
    frecuencia: 'mensual',
    fecha_inicio: new Date().toISOString().slice(0, 10),
    fecha_fin: '',
    serie: 'A',
    retencion_irpf_pct: 0,
    notas: '',
    activo: 1,
    lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
  });

  const [historialFactura, setHistorialFactura] = useState([]);
  const [historialPresupuesto, setHistorialPresupuesto] = useState([]);

  // Pagos de suscripciones (admin dashboard)
  const [subsPayments, setSubsPayments] = useState([]);
  const [subsFilterEstado, setSubsFilterEstado] = useState('todos');
  const [subsFilterUsuario, setSubsFilterUsuario] = useState('todos');
  const [subsFilterFactura, setSubsFilterFactura] = useState('todos');
  const [showSubsEmailModal, setShowSubsEmailModal] = useState(false);
  const [subsEmailPagoId, setSubsEmailPagoId] = useState(null);
  const [subsEmailForm, setSubsEmailForm] = useState({ email: '', mensaje: '' });
  const [subsEmailSending, setSubsEmailSending] = useState(false);

  // Factura rápida
  const [showQuickInvoice, setShowQuickInvoice] = useState(false);
  const [quickForm, setQuickForm] = useState({
    cliente_id: '',
    concepto: '',
    producto_servicio_id: null,
    cantidad: 1,
    precio_unitario: 0,
    iva_pct: 21,
    notas: '',
    target_type: 'cliente',
    usuario_plataforma_id: '',
  });
  const [quickSaving, setQuickSaving] = useState(false);
  const [platformUsers, setPlatformUsers] = useState([]);
  const location = useLocation();
  const locationHandled = useRef(false);
  const targetFacturaHandled = useRef(null);

  useEffect(() => {
    authAPI.check()
      .then(response => {
        if (response.data.authenticated && response.data.user) {
          setUser(response.data.user);
        }
      })
      .catch(() => {});
  }, []);

  const loadClientes = useCallback(async () => {
    try {
      const r = await clientesAPI.getAll(true);
      setClientes(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadConsultas = useCallback(async () => {
    try {
      const r = await consultasAPI.getAll();
      setConsultas(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadProductos = useCallback(async () => {
    try {
      const r = await productosServiciosAPI.getAll(false);
      setProductos(Array.isArray(r.data) ? r.data : []);
      setError(null);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar productos');
      setProductos([]);
      console.error(e);
    }
  }, []);

  const loadFacturas = useCallback(async () => {
    try {
      setLoading(true);
      const filters = {};
      if (filtroEstado) filters.estado = filtroEstado;
      if (filtroCliente) filters.cliente_id = filtroCliente;
      if (filtroFechaDesde) filters.fecha_desde = filtroFechaDesde;
      if (filtroFechaHasta) filters.fecha_hasta = filtroFechaHasta;
      const r = await facturasAPI.getAll(filters);
      let facturasData = Array.isArray(r.data) ? r.data : [];
      // Filtrar por búsqueda de número si existe
      if (filtroBusqueda.trim()) {
        const busqueda = filtroBusqueda.trim().toLowerCase();
        facturasData = facturasData.filter(f => 
          (f.numero && f.numero.toLowerCase().includes(busqueda)) ||
          (f.cliente_nombre && f.cliente_nombre.toLowerCase().includes(busqueda)) ||
          (f.cliente_apellidos && f.cliente_apellidos.toLowerCase().includes(busqueda))
        );
      }
      setFacturas(facturasData);
      setError(null);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar facturas');
      setFacturas([]);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [filtroEstado, filtroCliente, filtroBusqueda, filtroFechaDesde, filtroFechaHasta]);

  const loadTransacciones = useCallback(async () => {
    try {
      setLoading(true);
      const filters = {};
      if (filtroTransEstado) filters.estado = filtroTransEstado;
      if (filtroTransCliente) filters.cliente_id = filtroTransCliente;
      if (filtroTransFechaDesde) filters.fecha_desde = filtroTransFechaDesde;
      if (filtroTransFechaHasta) filters.fecha_hasta = filtroTransFechaHasta;
      const r = await pagosAPI.getTransacciones(filters);
      setTransacciones(Array.isArray(r.data?.transacciones) ? r.data.transacciones : []);
      setKpisCobros(r.data?.kpis || { cobrado_hoy: 0, cobrado_mes: 0, tasa_exito_cobro: 0 });
      setError(null);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar transacciones');
      setTransacciones([]);
    } finally {
      setLoading(false);
    }
  }, [filtroTransEstado, filtroTransCliente, filtroTransFechaDesde, filtroTransFechaHasta]);

  const loadPresupuestos = useCallback(async () => {
    try {
      setLoading(true);
      const filters = {};
      if (filtroPresEstado) filters.estado = filtroPresEstado;
      if (filtroPresCliente) filters.cliente_id = filtroPresCliente;
      const r = await presupuestosAPI.getAll(filters);
      setPresupuestos(Array.isArray(r.data) ? r.data : []);
      setError(null);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cargar presupuestos');
      setPresupuestos([]);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [filtroPresEstado, filtroPresCliente]);

  useEffect(() => {
    loadClientes();
    loadProductos();
    loadConsultas();
  }, [loadClientes, loadProductos, loadConsultas]);

  useEffect(() => {
    if (location.state?.crearFactura && !locationHandled.current) {
      locationHandled.current = true;
      setTab('facturas');
      handleNuevaFactura({
        cliente_id: location.state.cliente_id,
        consulta_id: location.state.consulta_id,
        descripcion_linea: location.state.descripcion_linea,
      });
      window.history.replaceState({}, document.title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  useEffect(() => {
    const targetFacturaId = location.state?.targetFacturaId;
    if (!targetFacturaId) return;
    if (targetFacturaHandled.current === targetFacturaId) return;

    setTab('facturas');
    setView('list');
  }, [location.state]);

  useEffect(() => {
    const targetFacturaId = location.state?.targetFacturaId;
    if (!targetFacturaId || tab !== 'facturas' || facturas.length === 0) return;
    if (targetFacturaHandled.current === targetFacturaId) return;

    const scrollAndHighlight = () => {
      const element = document.getElementById(`factura-${targetFacturaId}`);
      if (!element) return;
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const prevBg = element.style.backgroundColor;
      element.style.backgroundColor = '#fff3cd';
      setTimeout(() => {
        element.style.backgroundColor = prevBg;
      }, 1800);
      targetFacturaHandled.current = targetFacturaId;
      window.history.replaceState({}, document.title);
    };
    const t = setTimeout(scrollAndHighlight, 120);
    return () => clearTimeout(t);
  }, [location.state, tab, facturas]);

  const loadStats = useCallback(async () => {
    try {
      setStatsLoading(true);
      const r = await facturacionStatsAPI.getStats();
      setStats(r.data);
      setError(null);
    } catch (e) {
      console.error(e);
      setError(e.response?.data?.error || 'Error al cargar estadísticas');
    } finally {
      setStatsLoading(false);
    }
  }, []);

  const loadRecordatorios = useCallback(async () => {
    try {
      const r = await recordatoriosAPI.getRecordatorios();
      setRecordatorios(r.data);
    } catch (e) {
      console.error(e);
      setRecordatorios(null);
    }
  }, []);

  const loadSubsPayments = useCallback(async () => {
    try {
      const r = await pagosUsuariosAPI.getAll();
      let payments = [];
      if (Array.isArray(r.data?.data)) {
        payments = r.data.data;
      } else if (Array.isArray(r.data)) {
        payments = r.data;
      }
      setSubsPayments(payments);
    } catch (e) {
      console.error('Error loading subscription payments:', e);
      setSubsPayments([]);
    }
  }, []);

  const loadCodigosDescuento = useCallback(async () => {
    try {
      const r = await codigosDescuentoAPI.getAll(true);
      setCodigosDescuento(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
      setCodigosDescuento([]);
    }
  }, []);

  const loadDescuentosVolumen = useCallback(async () => {
    try {
      const r = await descuentosVolumenAPI.getAll();
      setDescuentosVolumen(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
      setDescuentosVolumen([]);
    }
  }, []);

  const loadTiposImpositivos = useCallback(async () => {
    try {
      const r = await tiposImpositivosAPI.getAll(false);
      setTiposImpositivos(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
      setTiposImpositivos([]);
    }
  }, []);

  const loadFacturasRecurrentes = useCallback(async () => {
    try {
      const r = await facturasRecurrentesAPI.getAll();
      setFacturasRecurrentes(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      console.error(e);
      setFacturasRecurrentes([]);
    }
  }, []);

  useEffect(() => {
    if (tab === 'facturas') loadFacturas();
    if (tab === 'presupuestos') loadPresupuestos();
    if (tab === 'dashboard') {
      loadStats();
      loadRecordatorios();
      if (user?.rol === 'admin') loadSubsPayments();
    }
    if (tab === 'promociones') {
      setPromoLoading(true);
      loadCodigosDescuento().then(() => setPromoLoading(false));
      loadDescuentosVolumen();
    }
    if (tab === 'productos') {
      loadProductos();
      loadTiposImpositivos();
    }
    if (tab === 'tipos_impositivos') loadTiposImpositivos();
    if (tab === 'recurrentes') loadFacturasRecurrentes();
    if (tab === 'transacciones') loadTransacciones();
  }, [tab, loadFacturas, loadPresupuestos, loadStats, loadRecordatorios, loadSubsPayments, user, loadCodigosDescuento, loadDescuentosVolumen, loadProductos, loadTiposImpositivos, loadFacturasRecurrentes, loadTransacciones]);

  const loadPagos = useCallback(async (facturaId) => {
    if (!facturaId) return;
    try {
      const r = await pagosAPI.getByFactura(facturaId);
      setFacturaPagos(r.data?.pagos ?? []);
      setTotalPagado(Number(r.data?.total_pagado ?? 0));
    } catch (e) {
      console.error(e);
      setFacturaPagos([]);
      setTotalPagado(0);
    }
  }, []);

  useEffect(() => {
    if (view === 'detail' && selectedFactura?.id) loadPagos(selectedFactura.id);
  }, [view, selectedFactura?.id, loadPagos]);

  const loadHistorialFactura = useCallback(async (facturaId) => {
    if (!facturaId) return;
    try {
      const r = await facturasAPI.getHistorial(facturaId);
      setHistorialFactura(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      setHistorialFactura([]);
    }
  }, []);

  const loadHistorialPresupuesto = useCallback(async (presupuestoId) => {
    if (!presupuestoId) return;
    try {
      const r = await presupuestosAPI.getHistorial(presupuestoId);
      setHistorialPresupuesto(Array.isArray(r.data) ? r.data : []);
    } catch (e) {
      setHistorialPresupuesto([]);
    }
  }, []);

  useEffect(() => {
    if (view === 'detail' && selectedFactura?.id) loadHistorialFactura(selectedFactura.id);
  }, [view, selectedFactura?.id, loadHistorialFactura]);

  useEffect(() => {
    if (presView === 'detail' && selectedPresupuesto?.id) loadHistorialPresupuesto(selectedPresupuesto.id);
  }, [presView, selectedPresupuesto?.id, loadHistorialPresupuesto]);

  const getClienteNombre = (id) => {
    const c = clientes.find((x) => x.id === id);
    return c ? `${c.nombre} ${c.apellidos}` : '';
  };

  const calcularTotales = (lineas, retencionIrpfPct = 0) => {
    let base = 0, iva = 0, descuentoTotal = 0;
    lineas.forEach((l) => {
      const q = Number(l.cantidad) || 0;
      const p = Number(l.precio_unitario) || 0;
      const tax = Number(l.iva_pct) || 0;
      const desc = Number(l.descuento_pct) || 0;
      const subtotal = Math.round(q * p * 100) / 100;
      const descuento = Math.round(subtotal * desc / 100 * 100) / 100;
      const b = Math.round((subtotal - descuento) * 100) / 100;
      const i = Math.round(b * tax / 100 * 100) / 100;
      base += b;
      iva += i;
      descuentoTotal += descuento;
    });
    const retencionIrpf = Math.round(base * retencionIrpfPct / 100 * 100) / 100;
    return { base, iva, descuento: descuentoTotal, retencionIrpf, total: Math.round((base + iva - retencionIrpf) * 100) / 100 };
  };

  const addLinea = () => {
    setForm((f) => ({ ...f, lineas: [...f.lineas, { descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
  };

  const removeLinea = (i) => {
    setForm((f) => ({ ...f, lineas: f.lineas.filter((_, j) => j !== i) }));
  };

  const updateLinea = (i, field, value) => {
    setForm((f) => {
      const next = [...f.lineas];
      next[i] = { ...next[i], [field]: value };
      return { ...f, lineas: next };
    });
  };

  const addLineaFromProducto = (p) => {
    const nueva = {
      descripcion: p.nombre,
      cantidad: 1,
      precio_unitario: Number(p.precio_unitario),
      iva_pct: Number(p.iva_pct),
      descuento_pct: 0,
      producto_servicio_id: p.id,
    };
    setForm((f) => ({ ...f, lineas: [...f.lineas, nueva] }));
  };

  const handleNuevaFactura = (presetData = null) => {
    setSelectedFactura(null);
    setForm({
      cliente_id: presetData?.cliente_id ? String(presetData.cliente_id) : '',
      serie: 'A',
      fecha_emision: new Date().toISOString().slice(0, 10),
      fecha_vencimiento: getFechaVencimientoDefault(),
      retencion_irpf_pct: 0,
      notas: '',
      notas_internas: '',
      codigo_descuento: '',
      consulta_id: presetData?.consulta_id ? String(presetData.consulta_id) : '',
      lineas: [{ descripcion: presetData?.descripcion_linea || '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
    });
    setView('form');
  };

  const handleEnviarEmail = (tipo, id, clienteEmail = '') => {
    setEmailTipo(tipo);
    setEmailId(id);
    setFormEmail({ email: clienteEmail || '', mensaje: '' });
    setShowEmailModal(true);
    setError(null);
  };

  const handleEnviarEmailSubmit = async () => {
    if (!formEmail.email || !formEmail.email.includes('@')) {
      setError('Email válido requerido');
      return;
    }

    try {
      setError(null);
      const response = await emailAPI.send(emailTipo, emailId, formEmail.email, formEmail.mensaje);
      if (response.data?.success) {
        setSuccess('Email enviado correctamente');
        setShowEmailModal(false);
        setFormEmail({ email: '', mensaje: '' });
        setTimeout(() => setSuccess(null), 3000);
      } else {
        setError(response.data?.error || 'Error al enviar email');
      }
    } catch (e) {
      setError(e.response?.data?.error || 'Error al enviar email');
    }
  };

  const handleVerFactura = async (f) => {
    try {
      setLoading(true);
      const r = await facturasAPI.getById(f.id);
      setSelectedFactura(r.data);
      setView('detail');
    } catch (e) {
      setError('Error al cargar la factura');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleEditarFactura = () => {
    if (!selectedFactura) return;
    setForm({
      cliente_id: String(selectedFactura.cliente_id),
      serie: selectedFactura.serie || 'A',
      numero: selectedFactura.numero || '',
      fecha_emision: selectedFactura.fecha_emision || new Date().toISOString().slice(0, 10),
      fecha_vencimiento: selectedFactura.fecha_vencimiento || '',
      retencion_irpf_pct: Number(selectedFactura.retencion_irpf_pct) || 0,
      notas: selectedFactura.notas || '',
      notas_internas: selectedFactura.notas_internas || '',
      codigo_descuento: selectedFactura.codigo_descuento_texto || '',
      consulta_id: selectedFactura.consulta_id ? String(selectedFactura.consulta_id) : '',
      lineas: (selectedFactura.lineas || []).map((l) => ({
        descripcion: l.descripcion,
        cantidad: Number(l.cantidad),
        precio_unitario: Number(l.precio_unitario),
        iva_pct: Number(l.iva_pct),
        descuento_pct: Number(l.descuento_pct) || 0,
        producto_servicio_id: l.producto_servicio_id || null,
      })),
    });
    if (selectedFactura.lineas?.length === 0) {
      setForm((f) => ({ ...f, lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
    }
    setView('form');
  };

  const handleSaveFactura = async () => {
    if (!form.cliente_id) {
      setError('Selecciona un cliente');
      return;
    }
    const lineas = form.lineas.filter((l) => l.descripcion.trim());
    if (lineas.length === 0) {
      setError('Añade al menos una línea');
      return;
    }
    // Validar fechas
    if (form.fecha_vencimiento && form.fecha_emision && new Date(form.fecha_vencimiento) < new Date(form.fecha_emision)) {
      setError('La fecha de vencimiento no puede ser anterior a la fecha de emisión');
      return;
    }
    // Validar líneas
    for (let i = 0; i < lineas.length; i++) {
      const l = lineas[i];
      if (Number(l.cantidad) <= 0) {
        setError(`La cantidad en la línea ${i + 1} debe ser mayor que 0`);
        return;
      }
      if (Number(l.precio_unitario) < 0) {
        setError(`El precio unitario en la línea ${i + 1} no puede ser negativo`);
        return;
      }
      if (Number(l.descuento_pct) < 0 || Number(l.descuento_pct) > 100) {
        setError(`El descuento en la línea ${i + 1} debe estar entre 0% y 100%`);
        return;
      }
      if (Number(l.iva_pct) < 0) {
        setError(`El IVA en la línea ${i + 1} no puede ser negativo`);
        return;
      }
    }
    setError(null);
    try {
      const payload = {
        cliente_id: form.cliente_id,
        serie: form.serie || 'A',
        ...(form.numero?.trim() ? { numero: form.numero.trim() } : {}),
        fecha_emision: form.fecha_emision,
        fecha_vencimiento: form.fecha_vencimiento || null,
        retencion_irpf_pct: Number(form.retencion_irpf_pct) || 0,
        notas: form.notas || null,
        notas_internas: form.notas_internas || null,
        codigo_descuento: (form.codigo_descuento || '').trim() || null,
        consulta_id: form.consulta_id || null,
        lineas: lineas.map((l) => ({
          descripcion: l.descripcion,
          cantidad: Number(l.cantidad),
          precio_unitario: Number(l.precio_unitario),
          iva_pct: Number(l.iva_pct),
          descuento_pct: Number(l.descuento_pct) || 0,
          producto_servicio_id: l.producto_servicio_id || null,
        })),
      };
      if (selectedFactura) {
        await facturasAPI.update(selectedFactura.id, payload);
        setSuccess('Factura actualizada');
      } else {
        await facturasAPI.create(payload);
        setSuccess('Factura creada');
      }
      setView('list');
      setSelectedFactura(null);
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar la factura');
    }
  };

  const handleDeleteFactura = async (id) => {
    if (!window.confirm('¿Eliminar esta factura?')) return;
    try {
      await facturasAPI.delete(id);
      setSuccess('Factura eliminada');
      setView('list');
      setSelectedFactura(null);
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar');
    }
  };

  const handleVolver = () => {
    setView('list');
    setSelectedFactura(null);
    setError(null);
    setShowPagoForm(false);
  };

  // ---- Factura rápida: handlers ----

  const isAdmin = user?.rol === 'admin';

  const loadPlatformUsers = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const r = await usuariosAPI.getAll(true);
      const users = Array.isArray(r.data) ? r.data : (Array.isArray(r.data?.usuarios) ? r.data.usuarios : []);
      setPlatformUsers(users.filter((u) => u.id !== user?.id));
    } catch (e) {
      console.error('Error loading platform users', e);
    }
  }, [isAdmin, user?.id]);

  useEffect(() => {
    if (isAdmin) loadPlatformUsers();
  }, [isAdmin, loadPlatformUsers]);

  const findOrCreateClientForUser = async (platformUser) => {
    const email = platformUser.email;
    const fiscalData = {
      nombre: platformUser.nombre || platformUser.username,
      apellidos: platformUser.apellidos || '',
      email: email,
      telefono: platformUser.telefono || '',
      direccion: platformUser.direccion || '',
      ciudad: platformUser.ciudad || '',
      provincia: platformUser.provincia || '',
      codigo_postal: platformUser.codigo_postal || '',
      pais: '',
      nif_cif: platformUser.nif_cif || '',
      nombre_empresa: platformUser.nombre_empresa || '',
      notas: `Usuario de plataforma (ID: ${platformUser.id})`,
    };
    const existing = clientes.find((c) => c.email && c.email.toLowerCase() === email.toLowerCase());
    if (existing) {
      // Update existing client with latest fiscal data if missing
      if (!existing.nif_cif && fiscalData.nif_cif) {
        try {
          await clientesAPI.update(existing.id, { ...existing, ...fiscalData });
          await loadClientes();
        } catch (e) {
          console.error('Could not update client fiscal data', e);
        }
      }
      return existing.id;
    }
    try {
      const r = await clientesAPI.create(fiscalData);
      await loadClientes();
      return r.data?.id || r.data?.cliente?.id;
    } catch (e) {
      throw new Error('No se pudo crear el registro de cliente para el usuario');
    }
  };

  const handleOpenQuickInvoice = () => {
    setQuickForm({
      cliente_id: '',
      concepto: '',
      producto_servicio_id: null,
      cantidad: 1,
      precio_unitario: 0,
      iva_pct: 21,
      notas: '',
      target_type: isAdmin ? 'usuario' : 'cliente',
      usuario_plataforma_id: '',
      numero: '',
    });
    setShowQuickInvoice(true);
    setError(null);
  };

  const handleQuickSelectProducto = (productoId) => {
    if (!productoId) {
      setQuickForm((f) => ({ ...f, producto_servicio_id: null, concepto: '', precio_unitario: 0, iva_pct: 21 }));
      return;
    }
    const p = productos.find((pr) => String(pr.id) === String(productoId));
    if (p) {
      setQuickForm((f) => ({
        ...f,
        producto_servicio_id: p.id,
        concepto: p.nombre,
        precio_unitario: Number(p.precio_unitario),
        iva_pct: Number(p.iva_pct),
      }));
    }
  };

  const handleSaveQuickInvoice = async () => {
    if (!quickForm.concepto.trim()) {
      setError('Indica el concepto');
      return;
    }
    if (Number(quickForm.precio_unitario) <= 0) {
      setError('El precio debe ser mayor que 0');
      return;
    }

    setQuickSaving(true);
    setError(null);
    try {
      let clienteId = quickForm.cliente_id;

      if (quickForm.target_type === 'usuario' && quickForm.usuario_plataforma_id) {
        const pu = platformUsers.find((u) => String(u.id) === String(quickForm.usuario_plataforma_id));
        if (!pu) {
          setError('Selecciona un usuario de plataforma');
          setQuickSaving(false);
          return;
        }
        clienteId = await findOrCreateClientForUser(pu);
        if (!clienteId) {
          setError('No se pudo asociar el usuario como cliente');
          setQuickSaving(false);
          return;
        }
      } else if (!clienteId) {
        setError('Selecciona un cliente o un usuario de plataforma');
        setQuickSaving(false);
        return;
      }

      const payload = {
        cliente_id: clienteId,
        serie: 'A',
        fecha_emision: new Date().toISOString().slice(0, 10),
        fecha_vencimiento: getFechaVencimientoDefault(),
        retencion_irpf_pct: 0,
        notas: quickForm.notas || null,
        ...(quickForm.numero?.trim() ? { numero: quickForm.numero.trim() } : {}),
        lineas: [{
          descripcion: quickForm.concepto.trim(),
          cantidad: Number(quickForm.cantidad) || 1,
          precio_unitario: Number(quickForm.precio_unitario),
          iva_pct: Number(quickForm.iva_pct),
          descuento_pct: 0,
          producto_servicio_id: quickForm.producto_servicio_id || null,
        }],
      };
      await facturasAPI.create(payload);
      setSuccess('Factura creada correctamente');
      setShowQuickInvoice(false);
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || e.message || 'Error al crear la factura');
    } finally {
      setQuickSaving(false);
    }
  };

  // ---- Presupuestos: handlers ----

  const presAddLinea = () => {
    setPresForm((f) => ({ ...f, lineas: [...f.lineas, { descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
  };

  const presRemoveLinea = (i) => {
    setPresForm((f) => ({ ...f, lineas: f.lineas.filter((_, j) => j !== i) }));
  };

  const presUpdateLinea = (i, field, value) => {
    setPresForm((f) => {
      const next = [...f.lineas];
      next[i] = { ...next[i], [field]: value };
      return { ...f, lineas: next };
    });
  };

  const presAddLineaFromProducto = (p) => {
    const nueva = {
      descripcion: p.nombre,
      cantidad: 1,
      precio_unitario: Number(p.precio_unitario),
      iva_pct: Number(p.iva_pct),
      descuento_pct: 0,
      producto_servicio_id: p.id,
    };
    setPresForm((f) => ({ ...f, lineas: [...f.lineas, nueva] }));
  };

  const handleNuevoPresupuesto = () => {
    setSelectedPresupuesto(null);
    setPresForm({
      cliente_id: '',
      serie: 'A',
      fecha_emision: new Date().toISOString().slice(0, 10),
      fecha_validez: getFechaVencimientoDefault(),
      retencion_irpf_pct: 0,
      notas: '',
      notas_internas: '',
      codigo_descuento: '',
      lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
    });
    setPresView('form');
  };

  const handleVerPresupuesto = async (p) => {
    try {
      setLoading(true);
      const r = await presupuestosAPI.getById(p.id);
      setSelectedPresupuesto(r.data);
      setPresView('detail');
    } catch (e) {
      setError('Error al cargar el presupuesto');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleEditarPresupuesto = () => {
    if (!selectedPresupuesto) return;
    setPresForm({
      cliente_id: String(selectedPresupuesto.cliente_id),
      serie: selectedPresupuesto.serie || 'A',
      fecha_emision: selectedPresupuesto.fecha_emision || new Date().toISOString().slice(0, 10),
      fecha_validez: selectedPresupuesto.fecha_validez || '',
      retencion_irpf_pct: Number(selectedPresupuesto.retencion_irpf_pct) || 0,
      notas: selectedPresupuesto.notas || '',
      notas_internas: selectedPresupuesto.notas_internas || '',
      codigo_descuento: selectedPresupuesto.codigo_descuento_texto || '',
      lineas: (selectedPresupuesto.lineas || []).map((l) => ({
        descripcion: l.descripcion,
        cantidad: Number(l.cantidad),
        precio_unitario: Number(l.precio_unitario),
        iva_pct: Number(l.iva_pct),
        descuento_pct: Number(l.descuento_pct) || 0,
        producto_servicio_id: l.producto_servicio_id || null,
      })),
    });
    if (selectedPresupuesto.lineas?.length === 0) {
      setPresForm((f) => ({ ...f, lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
    }
    setPresView('form');
  };

  const handleSavePresupuesto = async () => {
    if (!presForm.cliente_id) {
      setError('Selecciona un cliente');
      return;
    }
    const lineas = presForm.lineas.filter((l) => l.descripcion.trim());
    if (lineas.length === 0) {
      setError('Añade al menos una línea');
      return;
    }
    // Validar fechas
    if (presForm.fecha_validez && presForm.fecha_emision && new Date(presForm.fecha_validez) < new Date(presForm.fecha_emision)) {
      setError('La fecha de validez no puede ser anterior a la fecha de emisión');
      return;
    }
    // Validar líneas
    for (let i = 0; i < lineas.length; i++) {
      const l = lineas[i];
      if (Number(l.cantidad) <= 0) {
        setError(`La cantidad en la línea ${i + 1} debe ser mayor que 0`);
        return;
      }
      if (Number(l.precio_unitario) < 0) {
        setError(`El precio unitario en la línea ${i + 1} no puede ser negativo`);
        return;
      }
      if (Number(l.descuento_pct) < 0 || Number(l.descuento_pct) > 100) {
        setError(`El descuento en la línea ${i + 1} debe estar entre 0% y 100%`);
        return;
      }
      if (Number(l.iva_pct) < 0) {
        setError(`El IVA en la línea ${i + 1} no puede ser negativo`);
        return;
      }
    }
    setError(null);
    try {
      const payload = {
        cliente_id: presForm.cliente_id,
        serie: presForm.serie || 'A',
        fecha_emision: presForm.fecha_emision,
        fecha_validez: presForm.fecha_validez || null,
        retencion_irpf_pct: Number(presForm.retencion_irpf_pct) || 0,
        notas: presForm.notas || null,
        notas_internas: presForm.notas_internas || null,
        codigo_descuento: (presForm.codigo_descuento || '').trim() || null,
        lineas: lineas.map((l) => ({
          descripcion: l.descripcion,
          cantidad: Number(l.cantidad),
          precio_unitario: Number(l.precio_unitario),
          iva_pct: Number(l.iva_pct),
          descuento_pct: Number(l.descuento_pct) || 0,
          producto_servicio_id: l.producto_servicio_id || null,
        })),
      };
      if (selectedPresupuesto) {
        await presupuestosAPI.update(selectedPresupuesto.id, payload);
        setSuccess('Presupuesto actualizado');
      } else {
        await presupuestosAPI.create(payload);
        setSuccess('Presupuesto creado');
      }
      setPresView('list');
      setSelectedPresupuesto(null);
      loadPresupuestos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar el presupuesto');
    }
  };

  const handleDeletePresupuesto = async (id) => {
    if (!window.confirm('¿Eliminar este presupuesto?')) return;
    try {
      await presupuestosAPI.delete(id);
      setSuccess('Presupuesto eliminado');
      setPresView('list');
      setSelectedPresupuesto(null);
      loadPresupuestos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar presupuesto');
    }
  };

  const handleVolverPresupuesto = () => {
    setPresView('list');
    setSelectedPresupuesto(null);
    setError(null);
  };

  // ---- Facturas recurrentes: handlers ----
  const handleNuevaRecurrente = () => {
    setSelectedRecurrente(null);
    setRecForm({
      cliente_id: '',
      nombre: '',
      frecuencia: 'mensual',
      fecha_inicio: new Date().toISOString().slice(0, 10),
      fecha_fin: '',
      serie: 'A',
      retencion_irpf_pct: 0,
      notas: '',
      activo: 1,
      lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }],
    });
    setRecView('form');
  };

  const handleVerRecurrente = async (r) => {
    try {
      setLoading(true);
      const res = await facturasRecurrentesAPI.getById(r.id);
      setSelectedRecurrente(res.data);
      setRecView('detail');
    } catch (e) {
      setError('Error al cargar');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleEditarRecurrente = () => {
    if (!selectedRecurrente) return;
    setRecForm({
      cliente_id: String(selectedRecurrente.cliente_id),
      nombre: selectedRecurrente.nombre || '',
      frecuencia: selectedRecurrente.frecuencia || 'mensual',
      fecha_inicio: selectedRecurrente.fecha_inicio || new Date().toISOString().slice(0, 10),
      fecha_fin: selectedRecurrente.fecha_fin || '',
      serie: selectedRecurrente.serie || 'A',
      retencion_irpf_pct: Number(selectedRecurrente.retencion_irpf_pct) || 0,
      notas: selectedRecurrente.notas || '',
      activo: selectedRecurrente.activo ? 1 : 0,
      proxima_emision: selectedRecurrente.proxima_emision,
      lineas: (selectedRecurrente.lineas || []).map((l) => ({
        descripcion: l.descripcion,
        cantidad: Number(l.cantidad),
        precio_unitario: Number(l.precio_unitario),
        iva_pct: Number(l.iva_pct),
        descuento_pct: Number(l.descuento_pct) || 0,
        producto_servicio_id: l.producto_servicio_id || null,
      })),
    });
    if (!selectedRecurrente.lineas?.length) {
      setRecForm((f) => ({ ...f, lineas: [{ descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
    }
    setRecView('form');
  };

  const handleSaveRecurrente = async () => {
    if (!recForm.cliente_id) {
      setError('Selecciona un cliente');
      return;
    }
    const lineas = recForm.lineas.filter((l) => l.descripcion?.trim());
    if (lineas.length === 0) {
      setError('Añade al menos una línea');
      return;
    }
    setError(null);
    try {
      const payload = {
        cliente_id: recForm.cliente_id,
        nombre: (recForm.nombre || '').trim() || null,
        frecuencia: recForm.frecuencia,
        fecha_inicio: recForm.fecha_inicio,
        fecha_fin: (recForm.fecha_fin || '').trim() || null,
        serie: recForm.serie || 'A',
        retencion_irpf_pct: Number(recForm.retencion_irpf_pct) || 0,
        notas: (recForm.notas || '').trim() || null,
        activo: recForm.activo ? 1 : 0,
        lineas: lineas.map((l) => ({
          descripcion: l.descripcion,
          cantidad: Number(l.cantidad),
          precio_unitario: Number(l.precio_unitario),
          iva_pct: Number(l.iva_pct),
          descuento_pct: Number(l.descuento_pct) || 0,
          producto_servicio_id: l.producto_servicio_id || null,
        })),
      };
      if (selectedRecurrente) {
        if (recForm.proxima_emision) payload.proxima_emision = recForm.proxima_emision;
        await facturasRecurrentesAPI.update(selectedRecurrente.id, payload);
        setSuccess('Plantilla actualizada');
      } else {
        await facturasRecurrentesAPI.create(payload);
        setSuccess('Plantilla creada');
      }
      setRecView('list');
      setSelectedRecurrente(null);
      loadFacturasRecurrentes();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDeleteRecurrente = async (id) => {
    if (!window.confirm('¿Eliminar esta plantilla de factura recurrente?')) return;
    try {
      await facturasRecurrentesAPI.delete(id);
      setSuccess('Plantilla eliminada');
      setRecView('list');
      setSelectedRecurrente(null);
      loadFacturasRecurrentes();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar');
    }
  };

  const handleGenerarRecurrente = async (id) => {
    try {
      const r = await facturasRecurrentesAPI.generar(id);
      setSuccess(`Factura ${r.data?.factura?.numero || r.data?.factura_id} generada`);
      loadFacturasRecurrentes();
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo generar (quizá no toque emitir aún)');
    }
  };

  const addRecLinea = () => {
    setRecForm((f) => ({ ...f, lineas: [...f.lineas, { descripcion: '', cantidad: 1, precio_unitario: 0, iva_pct: 21, descuento_pct: 0, producto_servicio_id: null }] }));
  };
  const removeRecLinea = (i) => {
    setRecForm((f) => ({ ...f, lineas: f.lineas.filter((_, j) => j !== i) }));
  };
  const updateRecLinea = (i, field, value) => {
    setRecForm((f) => {
      const next = [...f.lineas];
      next[i] = { ...next[i], [field]: value };
      return { ...f, lineas: next };
    });
  };
  const addRecLineaFromProducto = (p) => {
    const nueva = {
      descripcion: p.nombre,
      cantidad: 1,
      precio_unitario: Number(p.precio_unitario),
      iva_pct: Number(p.iva_pct),
      descuento_pct: 0,
      producto_servicio_id: p.id,
    };
    setRecForm((f) => ({ ...f, lineas: [...f.lineas, nueva] }));
  };

  const handleCambiarEstadoPresupuesto = async (nuevoEstado) => {
    if (!selectedPresupuesto?.id) return;
    try {
      const r = await presupuestosAPI.updateEstado(selectedPresupuesto.id, nuevoEstado);
      setSelectedPresupuesto(r.data);
      setSuccess(`Presupuesto marcado como ${nuevoEstado}`);
      loadPresupuestos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cambiar estado');
    }
  };

  const handleDuplicarPresupuesto = async () => {
    if (!selectedPresupuesto?.id) return;
    try {
      const r = await presupuestosAPI.duplicate(selectedPresupuesto.id);
      setSuccess('Presupuesto duplicado');
      setSelectedPresupuesto(r.data);
      setPresView('detail');
      loadPresupuestos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al duplicar presupuesto');
    }
  };

  const handleAbrirPagoForm = () => {
    const restante = Math.max(0, Number(selectedFactura?.total ?? 0) - totalPagado);
    setFormPago({
      fecha: new Date().toISOString().slice(0, 10),
      importe: restante > 0 ? restante.toFixed(2) : '',
      metodo: 'transferencia',
      referencia: '',
      notas: '',
    });
    setShowPagoForm(true);
    setError(null);
  };

  const handleAddPago = async () => {
    if (!selectedFactura?.id) return;
    const imp = Number(formPago.importe);
    if (!imp || imp <= 0) {
      setError('Importe debe ser mayor que 0');
      return;
    }
    setError(null);
    try {
      const r = await pagosAPI.create({
        factura_id: selectedFactura.id,
        fecha: formPago.fecha,
        importe: imp,
        metodo: formPago.metodo,
        referencia: formPago.referencia || null,
        notas: formPago.notas || null,
      });
      setFacturaPagos(r.data?.pagos ?? []);
      setTotalPagado(Number(r.data?.total_pagado ?? 0));
      if (r.data?.estado) setSelectedFactura((prev) => (prev ? { ...prev, estado: r.data.estado } : null));
      setShowPagoForm(false);
      setSuccess('Pago registrado');
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al registrar pago');
    }
  };

  const handleDeletePago = async (pagoId) => {
    if (!selectedFactura?.id || !window.confirm('¿Eliminar este pago?')) return;
    try {
      const r = await pagosAPI.delete(pagoId, selectedFactura.id);
      setFacturaPagos(r.data?.pagos ?? []);
      setTotalPagado(Number(r.data?.total_pagado ?? 0));
      if (r.data?.estado) setSelectedFactura((prev) => (prev ? { ...prev, estado: r.data.estado } : null));
      setSuccess('Pago eliminado');
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar pago');
    }
  };

  const handleDescargarRecibo = (pagoId) => {
    const url = pagosAPI.getReciboUrl(pagoId, true);
    window.open(url, '_blank');
  };

  const handleEnviarReciboEmail = async (pagoId) => {
    const email = window.prompt('Introduce el email de destino para el recibo:');
    if (!email) return;
    try {
      await pagosAPI.sendReciboEmail(pagoId, email.trim());
      setSuccess('Recibo enviado por email');
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al enviar recibo por email');
    }
  };

  const handleReintentarPago = async (pagoId) => {
    if (!selectedFactura?.id) return;
    if (!window.confirm('¿Crear un reintento manual de este pago?')) return;
    try {
      const r = await pagosAPI.retry(pagoId, selectedFactura.id);
      setFacturaPagos(r.data?.pagos ?? []);
      setTotalPagado(Number(r.data?.total_pagado ?? 0));
      if (r.data?.estado) setSelectedFactura((prev) => (prev ? { ...prev, estado: r.data.estado } : null));
      setSuccess('Reintento de pago registrado');
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al reintentar pago');
    }
  };

  const limpiarFiltrosTransacciones = async () => {
    setFiltroTransEstado('');
    setFiltroTransCliente('');
    setFiltroTransFechaDesde('');
    setFiltroTransFechaHasta('');
    setFiltroTransBusqueda('');
    try {
      const r = await pagosAPI.getTransacciones({});
      setTransacciones(Array.isArray(r.data?.transacciones) ? r.data.transacciones : []);
      setKpisCobros(r.data?.kpis || { cobrado_hoy: 0, cobrado_mes: 0, tasa_exito_cobro: 0 });
    } catch (e) {
      setError(e.response?.data?.error || 'Error al recargar transacciones');
    }
  };

  const handleNuevoProducto = () => {
    setEditingProducto(null);
    setFormProducto({ nombre: '', descripcion: '', precio_unitario: 0, unidad: 'sesión', tipo: 'servicio', iva_pct: 21 });
    setShowProductoForm(true);
  };

  const handleEditProducto = (p) => {
    setEditingProducto(p);
    setFormProducto({
      nombre: p.nombre,
      descripcion: p.descripcion || '',
      precio_unitario: Number(p.precio_unitario),
      unidad: p.unidad || 'sesión',
      tipo: p.tipo || 'servicio',
      iva_pct: Number(p.iva_pct),
    });
    setShowProductoForm(true);
  };

  const handleSaveProducto = async () => {
    if (!formProducto.nombre.trim()) {
      setError('El nombre es obligatorio');
      return;
    }
    setError(null);
    try {
      if (editingProducto) {
        await productosServiciosAPI.update(editingProducto.id, formProducto);
        setSuccess('Producto actualizado');
      } else {
        await productosServiciosAPI.create(formProducto);
        setSuccess('Producto creado');
      }
      setShowProductoForm(false);
      setEditingProducto(null);
      loadProductos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDeleteProducto = async (id) => {
    if (!window.confirm('¿Eliminar este producto o servicio?')) return;
    try {
      await productosServiciosAPI.delete(id);
      setSuccess('Eliminado');
      loadProductos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar');
    }
  };

  const handleNuevoTipoImpositivo = () => {
    setEditingTipoImpositivo(null);
    setFormTipoImpositivo({ nombre: '', porcentaje: 21, orden: tiposImpositivos.length });
    setShowTipoImpositivoForm(true);
  };

  const handleEditTipoImpositivo = (t) => {
    setEditingTipoImpositivo(t);
    setFormTipoImpositivo({ nombre: t.nombre, porcentaje: Number(t.porcentaje), orden: Number(t.orden) });
    setShowTipoImpositivoForm(true);
  };

  const handleSaveTipoImpositivo = async () => {
    if (!formTipoImpositivo.nombre.trim()) {
      setError('El nombre es obligatorio');
      return;
    }
    setError(null);
    try {
      if (editingTipoImpositivo) {
        await tiposImpositivosAPI.update(editingTipoImpositivo.id, formTipoImpositivo);
        setSuccess('Tipo impositivo actualizado');
      } else {
        await tiposImpositivosAPI.create(formTipoImpositivo);
        setSuccess('Tipo impositivo creado');
      }
      setShowTipoImpositivoForm(false);
      setEditingTipoImpositivo(null);
      loadTiposImpositivos();
      loadProductos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDeleteTipoImpositivo = async (id) => {
    if (!window.confirm('¿Eliminar este tipo impositivo?')) return;
    try {
      await tiposImpositivosAPI.delete(id);
      setSuccess('Tipo impositivo eliminado');
      loadTiposImpositivos();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al eliminar');
    }
  };

  const tot = calcularTotales(form.lineas, form.retencion_irpf_pct);

  const presTot = calcularTotales(presForm.lineas, presForm.retencion_irpf_pct);

  // Exportar facturas a CSV
  const exportarFacturasCSV = () => {
    if (facturas.length === 0) {
      setError('No hay facturas para exportar');
      return;
    }
    const headers = ['Número', 'Cliente', 'Fecha Emisión', 'Fecha Vencimiento', 'Estado', 'Base Imponible', 'IVA', 'Total'];
    const rows = facturas.map(f => [
      f.numero || '',
      `${f.cliente_nombre || ''} ${f.cliente_apellidos || ''}`.trim(),
      f.fecha_emision || '',
      f.fecha_vencimiento || '',
      f.estado || '',
      Number(f.base_imponible || 0).toFixed(2),
      Number(f.importe_iva || 0).toFixed(2),
      Number(f.total || 0).toFixed(2),
    ]);
    const csvContent = [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `facturas_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    setSuccess('Facturas exportadas a CSV');
    setTimeout(() => setSuccess(null), 3000);
  };

  // Exportar presupuestos a CSV
  const exportarPresupuestosCSV = () => {
    if (presupuestos.length === 0) {
      setError('No hay presupuestos para exportar');
      return;
    }
    const headers = ['Número', 'Cliente', 'Fecha Emisión', 'Fecha Validez', 'Estado', 'Base Imponible', 'IVA', 'Total'];
    const rows = presupuestos.map(p => [
      p.numero || '',
      `${p.cliente_nombre || ''} ${p.cliente_apellidos || ''}`.trim(),
      p.fecha_emision || '',
      p.fecha_validez || '',
      p.estado || '',
      Number(p.base_imponible || 0).toFixed(2),
      Number(p.importe_iva || 0).toFixed(2),
      Number(p.total || 0).toFixed(2),
    ]);
    const csvContent = [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `presupuestos_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    setSuccess('Presupuestos exportados a CSV');
    setTimeout(() => setSuccess(null), 3000);
  };

  // Modal de envío de email (común a todas las vistas)
  const emailModal = showEmailModal && (
    <div className="modal-overlay" onClick={() => setShowEmailModal(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
        <h3>Enviar {emailTipo === 'factura' ? 'Factura' : emailTipo === 'factura_suscripcion' ? 'Factura de Suscripción' : 'Presupuesto'} por Email</h3>
        <div className="form-group">
          <label>Email del destinatario *</label>
          <input
            type="email"
            value={formEmail.email}
            onChange={(e) => setFormEmail(f => ({ ...f, email: e.target.value }))}
            placeholder="cliente@email.com"
            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>
        <div className="form-group">
          <label>Mensaje personalizado (opcional)</label>
          <textarea
            value={formEmail.mensaje}
            onChange={(e) => setFormEmail(f => ({ ...f, mensaje: e.target.value }))}
            rows={4}
            placeholder="Añade un mensaje personalizado que aparecerá antes del contenido estándar..."
            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>
        <div className="form-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button type="button" className="btn btn-secondary" onClick={() => {
            setShowEmailModal(false);
            setFormEmail({ email: '', mensaje: '' });
          }}>
            Cancelar
          </button>
          <button type="button" className="btn btn-primary" onClick={handleEnviarEmailSubmit}>
            📧 Enviar Email
          </button>
        </div>
      </div>
    </div>
  );

  // Modal de factura rápida
  const quickInvoiceModal = showQuickInvoice && (
    <div className="modal-overlay" onClick={() => setShowQuickInvoice(false)}>
      <div className="modal-content quick-invoice-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Factura rápida por concepto</h3>
        <p className="quick-invoice-hint">Crea una factura de un solo concepto de forma rápida.</p>
        {error && <div className="alert alert-error" style={{ marginBottom: '15px' }}>{error}</div>}

        {isAdmin ? (
          <div className="form-group">
            <label>Usuario de plataforma *</label>
            <select
              value={quickForm.usuario_plataforma_id}
              onChange={(e) => setQuickForm((f) => ({ ...f, usuario_plataforma_id: e.target.value }))}
            >
              <option value="">Seleccionar usuario...</option>
              {platformUsers.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.nombre || u.username} {u.apellidos || ''} ({u.email})
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className="form-group">
            <label>Cliente *</label>
            <select
              value={quickForm.cliente_id}
              onChange={(e) => setQuickForm((f) => ({ ...f, cliente_id: e.target.value }))}
            >
              <option value="">Seleccionar cliente...</option>
              {clientes.map((c) => (
                <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
              ))}
            </select>
          </div>
        )}

        {isAdmin && (
          <div className="form-group">
            <label>Nº de factura (dejar vacío para auto-generar)</label>
            <input
              type="text"
              value={quickForm.numero || ''}
              onChange={(e) => setQuickForm((f) => ({ ...f, numero: e.target.value }))}
              placeholder="Ej: 2026-001"
            />
          </div>
        )}

        <div className="form-group">
          <label>Concepto predefinido</label>
          <select
            value={quickForm.producto_servicio_id || ''}
            onChange={(e) => handleQuickSelectProducto(e.target.value)}
          >
            <option value="">— Seleccionar o escribir abajo —</option>
            {productos.map((p) => (
              <option key={p.id} value={p.id}>{p.nombre} — {Number(p.precio_unitario).toFixed(2)} €</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Concepto / Descripción *</label>
          <input
            type="text"
            value={quickForm.concepto}
            onChange={(e) => setQuickForm((f) => ({ ...f, concepto: e.target.value, producto_servicio_id: null }))}
            placeholder="Ej: Alta de servicio, Cambio de plan, Consultoría..."
          />
        </div>

        <div className="form-row" style={{ display: 'flex', gap: '15px' }}>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Cantidad</label>
            <input
              type="number"
              min="1"
              step="1"
              value={quickForm.cantidad}
              onChange={(e) => setQuickForm((f) => ({ ...f, cantidad: e.target.value }))}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>Precio unitario (€) *</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={quickForm.precio_unitario}
              onChange={(e) => setQuickForm((f) => ({ ...f, precio_unitario: e.target.value }))}
            />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label>IVA %</label>
            <input
              type="number"
              min="0"
              step="0.01"
              value={quickForm.iva_pct}
              onChange={(e) => setQuickForm((f) => ({ ...f, iva_pct: e.target.value }))}
            />
          </div>
        </div>

        {Number(quickForm.precio_unitario) > 0 && (
          <div className="quick-invoice-preview">
            <div className="quick-invoice-preview-row">
              <span>Base imponible:</span>
              <span>{(Number(quickForm.cantidad || 1) * Number(quickForm.precio_unitario)).toFixed(2)} €</span>
            </div>
            <div className="quick-invoice-preview-row">
              <span>IVA ({quickForm.iva_pct}%):</span>
              <span>{(Number(quickForm.cantidad || 1) * Number(quickForm.precio_unitario) * Number(quickForm.iva_pct) / 100).toFixed(2)} €</span>
            </div>
            <div className="quick-invoice-preview-row quick-invoice-total">
              <span>Total:</span>
              <span>{(Number(quickForm.cantidad || 1) * Number(quickForm.precio_unitario) * (1 + Number(quickForm.iva_pct) / 100)).toFixed(2)} €</span>
            </div>
          </div>
        )}

        <div className="form-group">
          <label>Notas (opcional)</label>
          <textarea
            value={quickForm.notas}
            onChange={(e) => setQuickForm((f) => ({ ...f, notas: e.target.value }))}
            rows={2}
            placeholder="Notas que aparecerán en la factura"
          />
        </div>

        <div className="form-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
          <button type="button" className="btn btn-secondary" onClick={() => setShowQuickInvoice(false)}>
            Cancelar
          </button>
          <button type="button" className="btn btn-primary" onClick={handleSaveQuickInvoice} disabled={quickSaving}>
            {quickSaving ? 'Creando...' : 'Crear factura'}
          </button>
        </div>
      </div>
    </div>
  );

  // ---- UI Facturas recurrentes ----
  if (tab === 'recurrentes') {
    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>Facturación</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>
              ← Facturas
            </button>
            {recView === 'list' && (
              <button type="button" className="btn btn-primary" onClick={handleNuevaRecurrente}>
                Nueva factura recurrente
              </button>
            )}
            {(recView === 'form' || recView === 'detail') && (
              <button type="button" className="btn btn-secondary" onClick={() => { setRecView('list'); setSelectedRecurrente(null); }}>
                ← Lista
              </button>
            )}
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <p className="facturacion-hint" style={{ marginBottom: '16px' }}>
          Las facturas recurrentes se generan automáticamente al abrir el CRM. Frecuencias: mensual, trimestral, semestral, anual.
        </p>
        {recView === 'list' && (
          <div className="table-wrap">
            <table className="table facturas-table">
              <thead>
                <tr>
                  <th>Nombre / Cliente</th>
                  <th>Frecuencia</th>
                  <th>Próxima emisión</th>
                  <th>Activo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {facturasRecurrentes.length === 0 && (
                  <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>No hay plantillas de facturas recurrentes. Crea una para generar facturas automáticamente.</td></tr>
                )}
                {facturasRecurrentes.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <strong>{r.nombre || 'Sin nombre'}</strong>
                      <br />
                      <small>{r.cliente_nombre} {r.cliente_apellidos}</small>
                    </td>
                    <td>{FRECUENCIAS_REC.find((f) => f.value === r.frecuencia)?.label || r.frecuencia}</td>
                    <td>{r.proxima_emision}</td>
                    <td>{r.activo ? 'Sí' : 'No'}</td>
                    <td>
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleVerRecurrente(r)}>Ver</button>
                      {' '}
                      <button type="button" className="btn btn-primary btn-sm" onClick={() => handleGenerarRecurrente(r.id)} title="Generar factura ahora (si toca emitir)">
                        Generar
                      </button>
                      {' '}
                      <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleDeleteRecurrente(r.id)}>Eliminar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {recView === 'detail' && selectedRecurrente && (
          <div className="facturacion-detail" style={{ maxWidth: '700px' }}>
            <h3>{selectedRecurrente.nombre || 'Factura recurrente'}</h3>
            <p><strong>Cliente:</strong> {selectedRecurrente.cliente_nombre} {selectedRecurrente.cliente_apellidos}</p>
            <p><strong>Frecuencia:</strong> {FRECUENCIAS_REC.find((f) => f.value === selectedRecurrente.frecuencia)?.label || selectedRecurrente.frecuencia}</p>
            <p><strong>Próxima emisión:</strong> {selectedRecurrente.proxima_emision}</p>
            <p><strong>Líneas:</strong></p>
            <ul>
              {(selectedRecurrente.lineas || []).map((l, i) => (
                <li key={i}>{l.descripcion} — {l.cantidad} × {Number(l.precio_unitario).toFixed(2)} € (IVA {l.iva_pct}%)</li>
              ))}
            </ul>
            <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
              <button type="button" className="btn btn-primary" onClick={() => handleGenerarRecurrente(selectedRecurrente.id)}>
                Generar factura ahora
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleEditarRecurrente}>Editar</button>
              <button type="button" className="btn btn-secondary" onClick={() => handleDeleteRecurrente(selectedRecurrente.id)}>Eliminar</button>
            </div>
          </div>
        )}
        {recView === 'form' && (
          <div className="facturacion-form" style={{ maxWidth: '700px' }}>
            <h3>{selectedRecurrente ? 'Editar' : 'Nueva'} factura recurrente</h3>
            <div className="form-group">
              <label>Cliente *</label>
              <select value={recForm.cliente_id} onChange={(e) => setRecForm((f) => ({ ...f, cliente_id: e.target.value }))} required>
                <option value="">Seleccionar...</option>
                {clientes.map((c) => (
                  <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Nombre (opcional)</label>
              <input type="text" value={recForm.nombre} onChange={(e) => setRecForm((f) => ({ ...f, nombre: e.target.value }))} placeholder="Ej: Mensualidad coaching María" />
            </div>
            <div className="form-group">
              <label>Frecuencia *</label>
              <select value={recForm.frecuencia} onChange={(e) => setRecForm((f) => ({ ...f, frecuencia: e.target.value }))}>
                {FRECUENCIAS_REC.map((f) => (
                  <option key={f.value} value={f.value}>{f.label}</option>
                ))}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div className="form-group">
                <label>Fecha inicio *</label>
                <input type="date" value={recForm.fecha_inicio} onChange={(e) => setRecForm((f) => ({ ...f, fecha_inicio: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Fecha fin (opcional)</label>
                <input type="date" value={recForm.fecha_fin} onChange={(e) => setRecForm((f) => ({ ...f, fecha_fin: e.target.value }))} />
              </div>
            </div>
            {selectedRecurrente && (
              <div className="form-group">
                <label>Próxima emisión (editable)</label>
                <input type="date" value={recForm.proxima_emision || ''} onChange={(e) => setRecForm((f) => ({ ...f, proxima_emision: e.target.value }))} />
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div className="form-group">
                <label>Serie</label>
                <input type="text" value={recForm.serie} onChange={(e) => setRecForm((f) => ({ ...f, serie: e.target.value }))} placeholder="A" />
              </div>
              <div className="form-group">
                <label>Retención IRPF %</label>
                <input type="number" step="0.01" min="0" value={recForm.retencion_irpf_pct} onChange={(e) => setRecForm((f) => ({ ...f, retencion_irpf_pct: e.target.value }))} />
              </div>
            </div>
            <div className="form-group">
              <label>
                <input type="checkbox" checked={!!recForm.activo} onChange={(e) => setRecForm((f) => ({ ...f, activo: e.target.checked ? 1 : 0 }))} />
                {' '}Activo (generar facturas automáticamente)
              </label>
            </div>
            <div className="form-group">
              <label>Notas</label>
              <textarea value={recForm.notas || ''} onChange={(e) => setRecForm((f) => ({ ...f, notas: e.target.value }))} rows={2} />
            </div>
            <div className="form-group">
              <label>Líneas *</label>
              {productos.length > 0 && (
                <div style={{ marginBottom: '8px' }}>
                  Añadir desde producto:{' '}
                  {productos.slice(0, 5).map((p) => (
                    <button key={p.id} type="button" className="btn btn-secondary btn-sm" onClick={() => addRecLineaFromProducto(p)}>{p.nombre}</button>
                  ))}
                  {productos.length > 5 && ' ...'}
                </div>
              )}
              {recForm.lineas.map((l, i) => (
                <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <input type="text" placeholder="Descripción" value={l.descripcion} onChange={(e) => updateRecLinea(i, 'descripcion', e.target.value)} style={{ flex: 2, minWidth: '120px' }} />
                  <input type="number" placeholder="Cant." value={l.cantidad} onChange={(e) => updateRecLinea(i, 'cantidad', e.target.value)} style={{ width: '70px' }} min="0" step="0.01" />
                  <input type="number" placeholder="Precio" value={l.precio_unitario} onChange={(e) => updateRecLinea(i, 'precio_unitario', e.target.value)} style={{ width: '90px' }} min="0" step="0.01" />
                  <input type="number" placeholder="IVA %" value={l.iva_pct} onChange={(e) => updateRecLinea(i, 'iva_pct', e.target.value)} style={{ width: '70px' }} min="0" step="0.01" />
                  <button type="button" className="btn btn-secondary btn-sm" onClick={() => removeRecLinea(i)}>×</button>
                </div>
              ))}
              <button type="button" className="btn btn-secondary btn-sm" onClick={addRecLinea}>+ Añadir línea</button>
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
              <button type="button" className="btn btn-primary" onClick={handleSaveRecurrente}>Guardar</button>
              <button type="button" className="btn btn-secondary" onClick={() => { setRecView('list'); setSelectedRecurrente(null); }}>Cancelar</button>
            </div>
          </div>
        )}
      </div>
      </>
    );
  }

  if (tab === 'productos') {
    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>Facturación</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>
              ← Facturas
            </button>
            <button type="button" className="btn btn-primary" onClick={handleNuevoProducto}>
              Nuevo producto o servicio
            </button>
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <div className="facturacion-content">
          <h3>Productos y servicios</h3>
          <p className="facturacion-hint">Usa el catálogo para rellenar líneas al crear facturas.</p>
          <div className="table-wrap">
            <table className="table facturas-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Precio</th>
                  <th>Unidad</th>
                  <th>Tipo</th>
                  <th>IVA %</th>
                  <th>Activo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {productos.map((p) => (
                  <tr key={p.id}>
                    <td>{p.nombre}</td>
                    <td>{Number(p.precio_unitario).toFixed(2)} €</td>
                    <td>{p.unidad}</td>
                    <td>{p.tipo}</td>
                    <td>{Number(p.iva_pct)}%</td>
                    <td>{p.activo ? 'Sí' : 'No'}</td>
                    <td>
                      <button type="button" className="btn btn-edit btn-sm" onClick={() => handleEditProducto(p)}>Editar</button>
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDeleteProducto(p.id)}>Borrar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {productos.length === 0 && <p className="empty-state">No hay productos ni servicios. Crea uno para usarlos en las facturas.</p>}
        </div>

        {showProductoForm && (
          <div className="modal-overlay" onClick={() => setShowProductoForm(false)}>
            <div className="factura-modal" onClick={(e) => e.stopPropagation()}>
              <h3>{editingProducto ? 'Editar' : 'Nuevo'} producto o servicio</h3>
              <div className="form-group">
                <label>Nombre *</label>
                <input type="text" value={formProducto.nombre} onChange={(e) => setFormProducto((f) => ({ ...f, nombre: e.target.value }))} />
              </div>
              <div className="form-group">
                <label>Descripción</label>
                <textarea value={formProducto.descripcion} onChange={(e) => setFormProducto((f) => ({ ...f, descripcion: e.target.value }))} rows={2} />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Precio unitario</label>
                  <input type="number" step="0.01" min="0" value={formProducto.precio_unitario} onChange={(e) => setFormProducto((f) => ({ ...f, precio_unitario: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label>Unidad</label>
                  <select value={formProducto.unidad} onChange={(e) => setFormProducto((f) => ({ ...f, unidad: e.target.value }))}>
                    {UNIDADES.map((u) => (
                      <option key={u} value={u}>{u}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Tipo</label>
                  <select value={formProducto.tipo} onChange={(e) => setFormProducto((f) => ({ ...f, tipo: e.target.value }))}>
                    <option value="servicio">Servicio</option>
                    <option value="producto">Producto</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>IVA %</label>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    {tiposImpositivos.length > 0 && (
                      <select
                        style={{ minWidth: '140px' }}
                        value=""
                        onChange={(e) => {
                          const id = e.target.value;
                          if (id) {
                            const t = tiposImpositivos.find((x) => x.id === Number(id));
                            if (t) setFormProducto((f) => ({ ...f, iva_pct: Number(t.porcentaje) }));
                          }
                        }}
                      >
                        <option value="">Usar tipo…</option>
                        {tiposImpositivos.map((t) => (
                          <option key={t.id} value={t.id}>{t.nombre} ({Number(t.porcentaje)}%)</option>
                        ))}
                      </select>
                    )}
                    <input type="number" step="0.01" min="0" value={formProducto.iva_pct} onChange={(e) => setFormProducto((f) => ({ ...f, iva_pct: e.target.value }))} style={{ width: '80px' }} />
                  </div>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowProductoForm(false)}>Cancelar</button>
                <button type="button" className="btn btn-primary" onClick={handleSaveProducto}>Guardar</button>
              </div>
            </div>
          </div>
        )}
      </div>
      </>
    );
  }

  if (tab === 'tipos_impositivos') {
    return (
      <>
        {emailModal}
        <div className="facturacion">
          <div className="page-header">
            <h2>Facturación</h2>
            <div className="facturacion-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>← Facturas</button>
              <button type="button" className="btn btn-primary" onClick={handleNuevoTipoImpositivo}>Nuevo tipo impositivo</button>
            </div>
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <div className="facturacion-content">
            <h3>Tipos impositivos</h3>
            <p className="facturacion-hint">Configura tipos de IVA (u otros impuestos) para usarlos en productos, facturas y presupuestos.</p>
            <div className="table-wrap">
              <table className="table facturas-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Porcentaje</th>
                    <th>Orden</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tiposImpositivos.map((t) => (
                    <tr key={t.id}>
                      <td>{t.nombre}</td>
                      <td>{Number(t.porcentaje)}%</td>
                      <td>{t.orden}</td>
                      <td>
                        <button type="button" className="btn btn-edit btn-sm" onClick={() => handleEditTipoImpositivo(t)}>Editar</button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDeleteTipoImpositivo(t.id)}>Borrar</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {tiposImpositivos.length === 0 && <p className="empty-state">No hay tipos impositivos. Crea uno (ej. IVA 21%, IVA reducido 10%) para seleccionarlos en productos y líneas.</p>}
          </div>

          {showTipoImpositivoForm && (
            <div className="modal-overlay" onClick={() => setShowTipoImpositivoForm(false)}>
              <div className="factura-modal" onClick={(e) => e.stopPropagation()}>
                <h3>{editingTipoImpositivo ? 'Editar' : 'Nuevo'} tipo impositivo</h3>
                <div className="form-group">
                  <label>Nombre *</label>
                  <input type="text" value={formTipoImpositivo.nombre} onChange={(e) => setFormTipoImpositivo((f) => ({ ...f, nombre: e.target.value }))} placeholder="Ej: IVA 21%" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Porcentaje</label>
                    <input type="number" step="0.01" min="0" value={formTipoImpositivo.porcentaje} onChange={(e) => setFormTipoImpositivo((f) => ({ ...f, porcentaje: e.target.value }))} />
                  </div>
                  <div className="form-group">
                    <label>Orden</label>
                    <input type="number" min="0" value={formTipoImpositivo.orden} onChange={(e) => setFormTipoImpositivo((f) => ({ ...f, orden: e.target.value }))} />
                  </div>
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowTipoImpositivoForm(false)}>Cancelar</button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveTipoImpositivo}>Guardar</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  if (tab === 'promociones') {
    const saveCodigo = async () => {
      if (!formCodigo.codigo.trim()) { setError('Código obligatorio'); return; }
      setError(null);
      try {
        const payload = { ...formCodigo, minimo_importe: Number(formCodigo.minimo_importe) || 0, valor: Number(formCodigo.valor) || 0, max_usos: formCodigo.max_usos === '' ? null : (Number(formCodigo.max_usos) || null), fecha_desde: formCodigo.fecha_desde || null, fecha_hasta: formCodigo.fecha_hasta || null };
        if (editingCodigoId) {
          await codigosDescuentoAPI.update(editingCodigoId, payload);
          setSuccess('Código actualizado');
        } else {
          await codigosDescuentoAPI.create(payload);
          setSuccess('Código creado');
        }
        setShowCodigoForm(false);
        setEditingCodigoId(null);
        loadCodigosDescuento();
        setTimeout(() => setSuccess(null), 3000);
      } catch (e) {
        setError(e.response?.data?.error || 'Error');
      }
    };
    const saveVolumen = async () => {
      if (!formVolumen.nombre.trim()) { setError('Nombre obligatorio'); return; }
      setError(null);
      try {
        const payload = { nombre: formVolumen.nombre, min_importe: Number(formVolumen.min_importe) || 0, descuento_pct: Number(formVolumen.descuento_pct) || 0, activo: formVolumen.activo ? 1 : 0 };
        if (editingVolumenId) {
          await descuentosVolumenAPI.update(editingVolumenId, payload);
          setSuccess('Descuento por volumen actualizado');
        } else {
          await descuentosVolumenAPI.create(payload);
          setSuccess('Descuento por volumen creado');
        }
        setShowVolumenForm(false);
        setEditingVolumenId(null);
        loadDescuentosVolumen();
        setTimeout(() => setSuccess(null), 3000);
      } catch (e) {
        setError(e.response?.data?.error || 'Error');
      }
    };
    return (
      <>
        {emailModal}
        <div className="facturacion">
          <div className="page-header">
            <h2>Promociones</h2>
            <div className="facturacion-actions">
              <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>← Facturas</button>
            </div>
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          <div className="facturacion-content">
            <h3>Códigos de descuento</h3>
            <p className="facturacion-hint">Códigos para aplicar en facturas y presupuestos (por tiempo limitado, usos, importe mínimo).</p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => { setEditingCodigoId(null); setFormCodigo({ codigo: '', nombre: '', tipo: 'porcentaje', valor: 0, fecha_desde: '', fecha_hasta: '', minimo_importe: 0, max_usos: '', activo: 1 }); setShowCodigoForm(true); }}>+ Código</button>
            {promoLoading ? <p className="loading">Cargando...</p> : (
              <div className="table-wrap" style={{ marginTop: '12px' }}>
                <table className="table facturas-table">
                  <thead><tr><th>Código</th><th>Nombre</th><th>Tipo</th><th>Valor</th><th>Válido</th><th>Usos</th><th>Activo</th><th></th></tr></thead>
                  <tbody>
                    {codigosDescuento.map((c) => (
                      <tr key={c.id}>
                        <td>{c.codigo}</td>
                        <td>{c.nombre || '-'}</td>
                        <td>{c.tipo}</td>
                        <td>{c.tipo === 'porcentaje' ? c.valor + '%' : c.valor + ' €'}</td>
                        <td>{(c.fecha_desde || '-') + ' / ' + (c.fecha_hasta || '-')}</td>
                        <td>{(c.usos_actuales || 0) + (c.max_usos ? '/' + c.max_usos : '')}</td>
                        <td>{c.activo ? 'Sí' : 'No'}</td>
                        <td>
                          <button type="button" className="btn btn-edit btn-sm" onClick={() => { setEditingCodigoId(c.id); setFormCodigo({ codigo: c.codigo, nombre: c.nombre || '', tipo: c.tipo || 'porcentaje', valor: Number(c.valor), fecha_desde: c.fecha_desde || '', fecha_hasta: c.fecha_hasta || '', minimo_importe: Number(c.minimo_importe || 0), max_usos: c.max_usos ?? '', activo: c.activo ? 1 : 0 }); setShowCodigoForm(true); }}>Editar</button>
                          <button type="button" className="btn btn-danger btn-sm" onClick={async () => { if (window.confirm('¿Eliminar este código?')) { try { await codigosDescuentoAPI.delete(c.id); loadCodigosDescuento(); setSuccess('Eliminado'); setTimeout(() => setSuccess(null), 3000); } catch (e) { setError(e.response?.data?.error); } } }}>Borrar</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <h3 style={{ marginTop: '28px' }}>Descuentos por volumen</h3>
            <p className="facturacion-hint">Desde importe mínimo, aplica un % de descuento.</p>
            <button type="button" className="btn btn-primary btn-sm" onClick={() => { setEditingVolumenId(null); setFormVolumen({ nombre: '', min_importe: 0, descuento_pct: 0, activo: 1 }); setShowVolumenForm(true); }}>+ Descuento volumen</button>
            <div className="table-wrap" style={{ marginTop: '12px' }}>
              <table className="table facturas-table">
                <thead><tr><th>Nombre</th><th>Desde (€)</th><th>Descuento %</th><th>Activo</th><th></th></tr></thead>
                <tbody>
                  {descuentosVolumen.map((v) => (
                    <tr key={v.id}>
                      <td>{v.nombre}</td>
                      <td>{Number(v.min_importe).toFixed(2)}</td>
                      <td>{Number(v.descuento_pct).toFixed(1)}%</td>
                      <td>{v.activo ? 'Sí' : 'No'}</td>
                      <td>
                        <button type="button" className="btn btn-edit btn-sm" onClick={() => { setEditingVolumenId(v.id); setFormVolumen({ nombre: v.nombre || '', min_importe: Number(v.min_importe), descuento_pct: Number(v.descuento_pct), activo: v.activo ? 1 : 0 }); setShowVolumenForm(true); }}>Editar</button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={async () => { if (window.confirm('¿Eliminar?')) { try { await descuentosVolumenAPI.delete(v.id); loadDescuentosVolumen(); setSuccess('Eliminado'); setTimeout(() => setSuccess(null), 3000); } catch (e) { setError(e.response?.data?.error); } } }}>Borrar</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {showCodigoForm && (
            <div className="modal-overlay" onClick={() => setShowCodigoForm(false)}>
              <div className="factura-modal" onClick={(e) => e.stopPropagation()}>
                <h3>{editingCodigoId ? 'Editar' : 'Nuevo'} código de descuento</h3>
                <div className="form-group"><label>Código *</label><input type="text" value={formCodigo.codigo} onChange={(e) => setFormCodigo(f => ({ ...f, codigo: e.target.value }))} placeholder="VERANO20" /></div>
                <div className="form-group"><label>Nombre</label><input type="text" value={formCodigo.nombre} onChange={(e) => setFormCodigo(f => ({ ...f, nombre: e.target.value }))} /></div>
                <div className="form-row">
                  <div className="form-group"><label>Tipo</label><select value={formCodigo.tipo} onChange={(e) => setFormCodigo(f => ({ ...f, tipo: e.target.value }))}><option value="porcentaje">Porcentaje</option><option value="fijo">Fijo (€)</option></select></div>
                  <div className="form-group"><label>Valor</label><input type="number" step="0.01" min="0" value={formCodigo.valor} onChange={(e) => setFormCodigo(f => ({ ...f, valor: e.target.value }))} /></div>
                  <div className="form-group"><label>Mín. importe (€)</label><input type="number" step="0.01" min="0" value={formCodigo.minimo_importe} onChange={(e) => setFormCodigo(f => ({ ...f, minimo_importe: e.target.value }))} /></div>
                  <div className="form-group"><label>Max usos (vacío=ilimitado)</label><input type="number" min="0" value={formCodigo.max_usos} onChange={(e) => setFormCodigo(f => ({ ...f, max_usos: e.target.value }))} placeholder="Ilimitado" /></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label>Válido desde</label><input type="date" value={formCodigo.fecha_desde} onChange={(e) => setFormCodigo(f => ({ ...f, fecha_desde: e.target.value }))} /></div>
                  <div className="form-group"><label>Válido hasta</label><input type="date" value={formCodigo.fecha_hasta} onChange={(e) => setFormCodigo(f => ({ ...f, fecha_hasta: e.target.value }))} /></div>
                  <div className="form-group"><label>Activo</label><input type="checkbox" checked={!!formCodigo.activo} onChange={(e) => setFormCodigo(f => ({ ...f, activo: e.target.checked ? 1 : 0 }))} /></div>
                </div>
                <div className="modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setShowCodigoForm(false)}>Cancelar</button><button type="button" className="btn btn-primary" onClick={saveCodigo}>Guardar</button></div>
              </div>
            </div>
          )}
          {showVolumenForm && (
            <div className="modal-overlay" onClick={() => setShowVolumenForm(false)}>
              <div className="factura-modal" onClick={(e) => e.stopPropagation()}>
                <h3>{editingVolumenId ? 'Editar' : 'Nuevo'} descuento por volumen</h3>
                <div className="form-group"><label>Nombre *</label><input type="text" value={formVolumen.nombre} onChange={(e) => setFormVolumen(f => ({ ...f, nombre: e.target.value }))} /></div>
                <div className="form-row">
                  <div className="form-group"><label>Importe mínimo (€)</label><input type="number" step="0.01" min="0" value={formVolumen.min_importe} onChange={(e) => setFormVolumen(f => ({ ...f, min_importe: e.target.value }))} /></div>
                  <div className="form-group"><label>Descuento %</label><input type="number" step="0.01" min="0" max="100" value={formVolumen.descuento_pct} onChange={(e) => setFormVolumen(f => ({ ...f, descuento_pct: e.target.value }))} /></div>
                  <div className="form-group"><label>Activo</label><input type="checkbox" checked={!!formVolumen.activo} onChange={(e) => setFormVolumen(f => ({ ...f, activo: e.target.checked ? 1 : 0 }))} /></div>
                </div>
                <div className="modal-actions"><button type="button" className="btn btn-secondary" onClick={() => setShowVolumenForm(false)}>Cancelar</button><button type="button" className="btn btn-primary" onClick={saveVolumen}>Guardar</button></div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  // ---- UI Presupuestos ----

  if (tab === 'presupuestos') {
    if (presView === 'detail' && selectedPresupuesto) {
      const p = selectedPresupuesto;
      const puedeEditar = p.estado === 'borrador';
      return (
        <>
          {emailModal}
        <div className="facturacion">
          <div className="page-header">
            <h2>Presupuesto {p.numero}</h2>
            <div className="facturacion-actions">
              <button type="button" className="btn btn-secondary" onClick={handleVolverPresupuesto}>← Volver</button>
              <a href={presupuestosAPI.getPdfUrl(p.id)} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Ver PDF</a>
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={() => handleEnviarEmail('presupuesto', p.id, p.cliente_email || '')}
              >
                📧 Enviar por Email
              </button>
              {(user?.rol === 'admin' || user?.whatsapp_habilitado === true || user?.whatsapp_habilitado === 1) && (
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ background: '#25D366', color: '#fff', border: 'none', padding: '6px 14px' }}
                  onClick={() => {
                    const phone = p.cliente_whatsapp || p.cliente_telefono || '';
                    if (!phone) { alert('El cliente no tiene teléfono/WhatsApp registrado'); return; }
                    const cleanPhone = phone.replace(/[^0-9]/g, '');
                    let texto = `Hola ${p.cliente_nombre || ''}, te envío el presupuesto nº ${p.numero || ''} por importe de ${Number(p.total || 0).toFixed(2)} €.`;
                    texto += `\n\nPuedes verlo aquí: ${window.location.origin}${presupuestosAPI.getPdfUrl(p.id)}`;
                    window.open(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(texto)}`, '_blank');
                  }}
                  title="Enviar por WhatsApp"
                >
                  WhatsApp
                </button>
              )}
              {p.estado === 'borrador' && (
                <button type="button" className="btn btn-info btn-sm" onClick={() => handleCambiarEstadoPresupuesto('enviado')}>
                  Marcar como enviado
                </button>
              )}
              {p.estado === 'enviado' && (
                <>
                  <button type="button" className="btn btn-success btn-sm" onClick={() => handleCambiarEstadoPresupuesto('aceptado')}>
                    Aceptado
                  </button>
                  <button type="button" className="btn btn-warning btn-sm" onClick={() => handleCambiarEstadoPresupuesto('rechazado')}>
                    Rechazado
                  </button>
                </>
              )}
              {(p.estado === 'enviado' || p.estado === 'aceptado') && (
                <button type="button" className="btn btn-warning btn-sm" onClick={() => handleCambiarEstadoPresupuesto('borrador')}>
                  Volver a borrador
                </button>
              )}
              <button type="button" className="btn btn-secondary btn-sm" onClick={handleDuplicarPresupuesto}>
                Duplicar
              </button>
              {puedeEditar && (
                <button type="button" className="btn btn-primary" onClick={handleEditarPresupuesto}>
                  Editar
                </button>
              )}
              {puedeEditar && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={async () => {
                    try {
                      const r = await presupuestosAPI.convertToFactura(p.id);
                      setSuccess('Presupuesto convertido a factura');
                      setTab('facturas');
                      if (r.data?.factura_id) {
                        const fr = await facturasAPI.getById(r.data.factura_id);
                        setSelectedFactura(fr.data);
                        setView('detail');
                      } else {
                        setView('list');
                        loadFacturas();
                      }
                    } catch (e) {
                      setError(e.response?.data?.error || 'Error al convertir a factura');
                    }
                  }}
                >
                  Convertir a factura
                </button>
              )}
              {puedeEditar && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleDeletePresupuesto(p.id)}
                >
                  Eliminar
                </button>
              )}
            </div>
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <div className="facturacion-content factura-detail">
            <div className="factura-cabecera">
              <p><strong>Cliente:</strong> {getClienteNombre(p.cliente_id) || p.cliente_nombre + ' ' + (p.cliente_apellidos || '')}</p>
              <p><strong>Serie:</strong> {p.serie || 'A'}</p>
              <p><strong>Número:</strong> {p.numero}</p>
              <p><strong>Fecha emisión:</strong> {p.fecha_emision ? new Date(p.fecha_emision).toLocaleDateString('es-ES') : '-'}</p>
              <p><strong>Válido hasta:</strong> {p.fecha_validez ? new Date(p.fecha_validez).toLocaleDateString('es-ES') : '-'}</p>
              <p><strong>Estado:</strong> {p.estado}</p>
              {p.notas && <p><strong>Notas (públicas):</strong> {p.notas}</p>}
              {p.notas_internas && <p style={{ color: '#666', fontStyle: 'italic' }}><strong>Notas internas:</strong> {p.notas_internas}</p>}
            </div>
            <div className="table-wrap">
              <table className="table facturas-table">
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Cant.</th>
                    <th>Precio u.</th>
                    <th>IVA %</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {(p.lineas || []).map((l) => (
                    <tr key={l.id}>
                      <td>{l.descripcion}</td>
                      <td>{Number(l.cantidad)}</td>
                      <td>{Number(l.precio_unitario).toFixed(2)} €</td>
                      <td>{Number(l.iva_pct)}%</td>
                      <td>{Number(l.total_linea).toFixed(2)} €</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="factura-totales">
              <p><strong>Base imponible:</strong> {Number(p.base_imponible).toFixed(2)} €</p>
              <p><strong>IVA:</strong> {Number(p.importe_iva).toFixed(2)} €</p>
              {Number(p.importe_descuento || 0) > 0 && (
                <p style={{ color: '#28a745' }}><strong>Descuento{p.codigo_descuento_texto ? ` (${p.codigo_descuento_texto})` : ''}:</strong> -{Number(p.importe_descuento).toFixed(2)} €</p>
              )}
              {p.importe_retencion_irpf > 0 && (
                <p style={{ color: '#dc3545' }}><strong>Retención IRPF ({Number(p.retencion_irpf_pct || 0)}%):</strong> -{Number(p.importe_retencion_irpf).toFixed(2)} €</p>
              )}
              <p><strong>Total:</strong> {Number(p.total).toFixed(2)} €</p>
            </div>
            <div className="factura-historial" style={{ marginTop: '24px', padding: '16px', background: '#f8f9fa', borderRadius: '8px' }}>
              <h3>Historial de cambios</h3>
              <p className="facturacion-hint">Quién hizo qué y cuándo. Puedes restaurar una versión anterior.</p>
              {historialPresupuesto.length === 0 ? (
                <p className="empty-state">Sin cambios registrados.</p>
              ) : (
                <div className="table-wrap" style={{ marginTop: '8px' }}>
                  <table className="table facturas-table">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Acción</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {historialPresupuesto.map((h) => (
                        <tr key={h.id}>
                          <td>{h.creado_en ? new Date(h.creado_en).toLocaleString('es-ES') : '-'}</td>
                          <td>{(h.usuario_nombre || '') + ' ' + (h.usuario_apellidos || '') || '-'}</td>
                          <td><span className={`estado-badge estado-${h.accion}`}>{h.accion}</span></td>
                          <td>
                            {h.snapshot_nuevo && h.accion !== 'eliminar' && (
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                onClick={async () => {
                                  if (!window.confirm('¿Restaurar el presupuesto a esta versión? Se sobrescribirán los datos actuales.')) return;
                                  try {
                                    const r = await presupuestosAPI.restaurar(p.id, h.id);
                                    setSelectedPresupuesto(r.data);
                                    loadHistorialPresupuesto(p.id);
                                    setSuccess('Versión restaurada');
                                    setTimeout(() => setSuccess(null), 3000);
                                  } catch (e) {
                                    setError(e.response?.data?.error || 'Error al restaurar');
                                  }
                                }}
                              >
                                Restaurar
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        </>
      );
    }

    if (presView === 'form') {
      return (
        <>
          {emailModal}
        <div className="facturacion">
          <div className="page-header">
            <h2>{selectedPresupuesto ? 'Editar presupuesto' : 'Nuevo presupuesto'}</h2>
            <div className="facturacion-actions">
              <button type="button" className="btn btn-secondary" onClick={handleVolverPresupuesto}>← Volver</button>
              <button type="button" className="btn btn-primary" onClick={handleSavePresupuesto}>Guardar</button>
            </div>
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <div className="facturacion-content factura-form">
            <div className="form-row">
            <div className="form-group">
              <label>Cliente *</label>
              <select value={presForm.cliente_id} onChange={(e) => setPresForm((f) => ({ ...f, cliente_id: e.target.value }))}>
                <option value="">Seleccionar...</option>
                {clientes.map((c) => (
                  <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Serie</label>
              <select value={presForm.serie} onChange={(e) => setPresForm((f) => ({ ...f, serie: e.target.value }))}>
                <option value="A">A - General</option>
                <option value="B">B - Simplificada</option>
                <option value="C">C - Recargo de equivalencia</option>
              </select>
            </div>
            <div className="form-group">
              <label>Fecha emisión</label>
              <input
                type="date"
                value={presForm.fecha_emision}
                onChange={(e) => setPresForm((f) => ({ ...f, fecha_emision: e.target.value }))}
              />
            </div>
            <div className="form-group">
              <label>Válido hasta</label>
              <input
                type="date"
                value={presForm.fecha_validez}
                onChange={(e) => setPresForm((f) => ({ ...f, fecha_validez: e.target.value }))}
              />
            </div>
            <div className="form-group">
              <label>Retención IRPF %</label>
              <input type="number" step="0.01" min="0" max="100" value={presForm.retencion_irpf_pct} onChange={(e) => setPresForm((f) => ({ ...f, retencion_irpf_pct: e.target.value }))} placeholder="0" />
            </div>
            </div>
              <div className="form-group">
                <label>Notas (visibles en PDF para el cliente)</label>
                <textarea
                  value={presForm.notas}
                  onChange={(e) => setPresForm((f) => ({ ...f, notas: e.target.value }))}
                  rows={2}
                  placeholder="Notas que aparecerán en el PDF del presupuesto"
                />
              </div>
              <div className="form-group">
                <label>Notas internas (solo para ti)</label>
                <textarea
                  value={presForm.notas_internas}
                  onChange={(e) => setPresForm((f) => ({ ...f, notas_internas: e.target.value }))}
                  rows={2}
                  placeholder="Notas privadas que no se mostrarán al cliente"
                />
              </div>
              <div className="form-group">
                <label>Código descuento</label>
                <input
                  type="text"
                  value={presForm.codigo_descuento || ''}
                  onChange={(e) => setPresForm((f) => ({ ...f, codigo_descuento: e.target.value }))}
                  placeholder="Ej. VERANO20"
                  style={{ maxWidth: '200px' }}
                />
              </div>

            <div className="factura-lineas-header">
              <h3>Líneas</h3>
              <div>
                {productos.length > 0 && (
                  <select
                    className="select-producto"
                    value=""
                    onChange={(e) => {
                      const id = e.target.value;
                      if (!id) return;
                      const prod = productos.find((x) => x.id === Number(id));
                      if (prod) presAddLineaFromProducto(prod);
                      e.target.value = '';
                    }}
                  >
                    <option value="">Añadir desde catálogo...</option>
                    {productos.map((p) => (
                      <option key={p.id} value={p.id}>{p.nombre} – {Number(p.precio_unitario).toFixed(2)} €</option>
                    ))}
                  </select>
                )}
                <button type="button" className="btn btn-secondary btn-sm" onClick={presAddLinea}>+ Línea</button>
              </div>
            </div>
            <div className="table-wrap">
              <table className="table facturas-table">
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Cant.</th>
                    <th>P. unit.</th>
                    <th>Desc. %</th>
                    <th>IVA %</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {presForm.lineas.map((l, i) => (
                    <tr key={i}>
                      <td>
                        <input
                          type="text"
                          value={l.descripcion}
                          onChange={(e) => presUpdateLinea(i, 'descripcion', e.target.value)}
                          placeholder="Descripción"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          style={{ width: '70px' }}
                          value={l.cantidad}
                          onChange={(e) => presUpdateLinea(i, 'cantidad', e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          style={{ width: '90px' }}
                          value={l.precio_unitario}
                          onChange={(e) => presUpdateLinea(i, 'precio_unitario', e.target.value)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          max="100"
                          style={{ width: '70px' }}
                          value={l.descuento_pct || 0}
                          onChange={(e) => presUpdateLinea(i, 'descuento_pct', e.target.value)}
                          placeholder="0"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          style={{ width: '60px' }}
                          value={l.iva_pct}
                          onChange={(e) => presUpdateLinea(i, 'iva_pct', e.target.value)}
                        />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => presRemoveLinea(i)}
                          disabled={presForm.lineas.length === 1}
                        >
                          ×
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="factura-totales">
              {presTot.descuento > 0 && (
                <p style={{ color: '#28a745' }}><strong>Descuento total:</strong> -{presTot.descuento.toFixed(2)} €</p>
              )}
              <p><strong>Base:</strong> {presTot.base.toFixed(2)} €</p>
              <p><strong>IVA:</strong> {presTot.iva.toFixed(2)} €</p>
              {presTot.retencionIrpf > 0 && (
                <p style={{ color: '#dc3545' }}><strong>Retención IRPF ({presForm.retencion_irpf_pct}%):</strong> -{presTot.retencionIrpf.toFixed(2)} €</p>
              )}
              <p><strong>Total:</strong> {presTot.total.toFixed(2)} €</p>
            </div>
          </div>
        </div>
        </>
      );
    }

    // Lista de presupuestos
    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>Presupuestos</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={() => { setTab('facturas'); setView('list'); }}>
              ← Facturas
            </button>
            <button type="button" className="btn btn-primary" onClick={handleNuevoPresupuesto}>
              Nuevo presupuesto
            </button>
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div className="facturacion-filters">
          <div className="filters-row">
            <select value={filtroPresEstado} onChange={(e) => setFiltroPresEstado(e.target.value)}>
              <option value="">Todos los estados</option>
              {ESTADOS_PRESUPUESTO.map((e) => (
                <option key={e} value={e}>{e}</option>
              ))}
            </select>
            <select value={filtroPresCliente} onChange={(e) => setFiltroPresCliente(e.target.value)}>
              <option value="">Todos los clientes</option>
              {clientes.map((c) => (
                <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
              ))}
            </select>
            <button type="button" className="btn btn-secondary btn-sm" onClick={exportarPresupuestosCSV}>
              📥 Exportar CSV
            </button>
          </div>
        </div>

        <div className="facturacion-content">
          {loading ? (
            <p className="loading">Cargando presupuestos...</p>
          ) : (
            <>
              <div className="table-wrap">
                <table className="table facturas-table">
                  <thead>
                    <tr>
                      <th>Número</th>
                      <th>Cliente</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {presupuestos.map((p) => (
                      <tr key={p.id}>
                        <td>{p.numero}</td>
                        <td>{getClienteNombre(p.cliente_id) || (p.cliente_nombre + ' ' + (p.cliente_apellidos || ''))}</td>
                        <td>{p.fecha_emision ? new Date(p.fecha_emision).toLocaleDateString('es-ES') : '-'}</td>
                        <td><span className={`estado-badge estado-${p.estado}`}>{p.estado}</span></td>
                        <td>{Number(p.total).toFixed(2)} €</td>
                        <td>
                          <button type="button" className="btn btn-edit btn-sm" onClick={() => handleVerPresupuesto(p)}>
                            Ver
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            style={{ marginLeft: '4px' }}
                            onClick={async () => {
                              try {
                                const r = await presupuestosAPI.duplicate(p.id);
                                setSuccess('Presupuesto duplicado');
                                setSelectedPresupuesto(r.data);
                                setPresView('detail');
                                loadPresupuestos();
                                setTimeout(() => setSuccess(null), 3000);
                              } catch (e) {
                                setError(e.response?.data?.error || 'Error al duplicar');
                              }
                            }}
                          >
                            Duplicar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {presupuestos.length === 0 && (
                <p className="empty-state">No hay presupuestos. Crea el primero con &quot;Nuevo presupuesto&quot;.</p>
              )}
            </>
          )}
        </div>
      </div>
      </>
    );
  }

  const handleCambiarEstadoFactura = async (nuevoEstado) => {
    if (!selectedFactura?.id) return;
    try {
      const r = await facturasAPI.updateEstado(selectedFactura.id, nuevoEstado);
      setSelectedFactura(r.data);
      setSuccess(`Factura marcada como ${nuevoEstado}`);
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al cambiar estado');
    }
  };

  const handleDuplicarFactura = async () => {
    if (!selectedFactura?.id) return;
    try {
      const r = await facturasAPI.duplicate(selectedFactura.id);
      setSuccess('Factura duplicada');
      setSelectedFactura(r.data);
      setView('detail');
      loadFacturas();
      setTimeout(() => setSuccess(null), 3000);
    } catch (e) {
      setError(e.response?.data?.error || 'Error al duplicar factura');
    }
  };

  if (view === 'detail' && selectedFactura) {
    const f = selectedFactura;
    const puedeEditar = f.estado === 'borrador';
    return (
      <div className="facturacion">
        {emailModal}
        <div className="page-header">
          <h2>Factura {f.numero}</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={handleVolver}>← Volver</button>
            <a href={facturasAPI.getPdfUrl(f.id)} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">Ver PDF</a>
            {(user?.einvoice_habilitado === true || user?.einvoice_habilitado === 1 || user?.rol === 'admin') && (
              <a href={facturasAPI.getEinvoiceUrl(f.id)} target="_blank" rel="noopener noreferrer" className="btn btn-secondary" title="Factura electrónica UE (UBL 2.1 / EN 16931)">📄 e-invoice (XML)</a>
            )}
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={() => handleEnviarEmail('factura', f.id, f.cliente_email || '')}
            >
              📧 Enviar por Email
            </button>
            {(user?.rol === 'admin' || user?.whatsapp_habilitado === true || user?.whatsapp_habilitado === 1) && (
              <button
                type="button"
                className="btn btn-sm"
                style={{ background: '#25D366', color: '#fff', border: 'none', padding: '6px 14px' }}
                onClick={() => {
                  const phone = f.cliente_whatsapp || f.cliente_telefono || '';
                  if (!phone) { alert('El cliente no tiene teléfono/WhatsApp registrado'); return; }
                  const cleanPhone = phone.replace(/[^0-9]/g, '');
                  let texto = `Hola ${f.cliente_nombre || ''}, te envío la factura nº ${f.numero || ''} por importe de ${Number(f.total || 0).toFixed(2)} €.`;
                  texto += `\n\nPuedes ver tu factura aquí: ${window.location.origin}${facturasAPI.getPdfUrl(f.id)}`;
                  window.open(`https://wa.me/${cleanPhone}?text=${encodeURIComponent(texto)}`, '_blank');
                }}
                title="Enviar por WhatsApp"
              >
                WhatsApp
              </button>
            )}
            {f.estado === 'borrador' && (
              <button type="button" className="btn btn-info btn-sm" onClick={() => handleCambiarEstadoFactura('enviada')}>
                Marcar como enviada
              </button>
            )}
            {f.estado === 'enviada' && (
              <button type="button" className="btn btn-warning btn-sm" onClick={() => handleCambiarEstadoFactura('borrador')}>
                Volver a borrador
              </button>
            )}
            <button type="button" className="btn btn-secondary btn-sm" onClick={handleDuplicarFactura}>
              Duplicar
            </button>
            {puedeEditar && <button type="button" className="btn btn-primary" onClick={handleEditarFactura}>Editar</button>}
            {puedeEditar && <button type="button" className="btn btn-danger" onClick={() => handleDeleteFactura(f.id)}>Eliminar</button>}
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <div className="facturacion-content factura-detail">
          <div className="factura-cabecera">
            <p><strong>Cliente:</strong> {getClienteNombre(f.cliente_id) || f.cliente_nombre + ' ' + (f.cliente_apellidos || '')}</p>
            <p><strong>Serie:</strong> {f.serie || 'A'}</p>
            <p><strong>Número:</strong> {f.numero}</p>
            <p><strong>Fecha emisión:</strong> {f.fecha_emision ? new Date(f.fecha_emision).toLocaleDateString('es-ES') : '-'}</p>
            <p><strong>Fecha vencimiento:</strong> {f.fecha_vencimiento ? new Date(f.fecha_vencimiento).toLocaleDateString('es-ES') : '-'}</p>
            <p><strong>Estado:</strong> {f.estado}</p>
            {f.consulta_id && (() => {
              const sesion = consultas.find(c => c.id === Number(f.consulta_id));
              if (!sesion) return <p><strong>Sesión asociada:</strong> #{f.consulta_id}</p>;
              const clienteNom = clientes.find(cl => cl.id === sesion.cliente_id);
              const nombre = clienteNom ? `${clienteNom.nombre} ${clienteNom.apellidos}` : '';
              const fecha = sesion.fecha_consulta ? new Date(sesion.fecha_consulta).toLocaleDateString('es-ES') : '';
              return <p><strong>Sesión asociada:</strong> #{sesion.numero_sesion} - {nombre} - {fecha}</p>;
            })()}
            {f.notas && <p><strong>Notas (públicas):</strong> {f.notas}</p>}
            {f.notas_internas && <p style={{ color: '#666', fontStyle: 'italic' }}><strong>Notas internas:</strong> {f.notas_internas}</p>}
          </div>
          <div className="table-wrap">
            <table className="table facturas-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th>Cant.</th>
                  <th>Precio u.</th>
                  <th>IVA %</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {(f.lineas || []).map((l) => (
                  <tr key={l.id}>
                    <td>{l.descripcion}</td>
                    <td>{Number(l.cantidad)}</td>
                    <td>{Number(l.precio_unitario).toFixed(2)} €</td>
                    <td>{Number(l.iva_pct)}%</td>
                    <td>{Number(l.total_linea).toFixed(2)} €</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="factura-totales">
            <p><strong>Base imponible:</strong> {Number(f.base_imponible).toFixed(2)} €</p>
            <p><strong>IVA:</strong> {Number(f.importe_iva).toFixed(2)} €</p>
            {Number(f.importe_descuento || 0) > 0 && (
              <p style={{ color: '#28a745' }}><strong>Descuento{f.codigo_descuento_texto ? ` (${f.codigo_descuento_texto})` : ''}:</strong> -{Number(f.importe_descuento).toFixed(2)} €</p>
            )}
            {f.importe_retencion_irpf > 0 && (
              <p style={{ color: '#dc3545' }}><strong>Retención IRPF ({Number(f.retencion_irpf_pct || 0)}%):</strong> -{Number(f.importe_retencion_irpf).toFixed(2)} €</p>
            )}
            <p><strong>Total:</strong> {Number(f.total).toFixed(2)} €</p>
          </div>

          <div className="factura-pagos">
            <h3>Pagos</h3>
            <p><strong>Total pagado:</strong> {Number(totalPagado).toFixed(2)} € · <strong>Restante:</strong> {Math.max(0, Number(f.total) - totalPagado).toFixed(2)} €</p>
            {facturaPagos.length > 0 && (
              <div className="table-wrap">
                <table className="table facturas-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Importe</th>
                      <th>Tipo</th>
                      <th>Estado</th>
                      <th>Método</th>
                      <th>Referencia</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {facturaPagos.map((p) => (
                      <tr key={p.id}>
                        <td>{p.fecha ? new Date(p.fecha).toLocaleDateString('es-ES') : '-'}</td>
                        <td>{Number(p.importe).toFixed(2)} €</td>
                        <td>{p.tipo_movimiento || 'cobro'}</td>
                        <td>
                          <span className={`estado-badge estado-${(p.estado || 'confirmado').replace(/\s+/g, '-')}`}>
                            {p.estado || 'confirmado'}
                          </span>
                        </td>
                        <td>{p.metodo || '-'}</td>
                        <td>{p.referencia || '-'}</td>
                        <td>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleDescargarRecibo(p.id)}>Recibo</button>
                          <button type="button" className="btn btn-secondary btn-sm" style={{ marginLeft: '4px' }} onClick={() => handleEnviarReciboEmail(p.id)}>Email</button>
                          {(p.estado === 'cancelado') && (
                            <button type="button" className="btn btn-primary btn-sm" style={{ marginLeft: '4px' }} onClick={() => handleReintentarPago(p.id)}>Reintentar</button>
                          )}
                          <button type="button" className="btn btn-danger btn-sm" style={{ marginLeft: '4px' }} onClick={() => handleDeletePago(p.id)}>Cancelar</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {f.estado !== 'cancelada' && (
              <>
                {!showPagoForm ? (
                  <button type="button" className="btn btn-secondary btn-sm" onClick={handleAbrirPagoForm}>+ Añadir pago</button>
                ) : (
                  <div className="form-inline-pago">
                    <input type="date" value={formPago.fecha} onChange={(e) => setFormPago((x) => ({ ...x, fecha: e.target.value }))} />
                    <input type="number" step="0.01" min="0.01" placeholder="Importe" value={formPago.importe} onChange={(e) => setFormPago((x) => ({ ...x, importe: e.target.value }))} />
                    <select value={formPago.metodo} onChange={(e) => setFormPago((x) => ({ ...x, metodo: e.target.value }))}>
                      {METODOS_PAGO.map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </select>
                    <input type="text" placeholder="Referencia" value={formPago.referencia} onChange={(e) => setFormPago((x) => ({ ...x, referencia: e.target.value }))} />
                    <button type="button" className="btn btn-primary btn-sm" onClick={handleAddPago}>Guardar</button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowPagoForm(false)}>Cancelar</button>
                  </div>
                )}
              </>
            )}

            <div className="factura-historial" style={{ marginTop: '24px', padding: '16px', background: '#f8f9fa', borderRadius: '8px' }}>
              <h3>Historial de cambios</h3>
              <p className="facturacion-hint">Quién hizo qué y cuándo. Puedes restaurar una versión anterior.</p>
              {historialFactura.length === 0 ? (
                <p className="empty-state">Sin cambios registrados.</p>
              ) : (
                <div className="table-wrap" style={{ marginTop: '8px' }}>
                  <table className="table facturas-table">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Usuario</th>
                        <th>Acción</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {historialFactura.map((h) => (
                        <tr key={h.id}>
                          <td>{h.creado_en ? new Date(h.creado_en).toLocaleString('es-ES') : '-'}</td>
                          <td>{(h.usuario_nombre || '') + ' ' + (h.usuario_apellidos || '') || '-'}</td>
                          <td><span className={`estado-badge estado-${h.accion}`}>{h.accion}</span></td>
                          <td>
                            {h.snapshot_nuevo && h.accion !== 'eliminar' && (
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                onClick={async () => {
                                  if (!window.confirm('¿Restaurar la factura a esta versión? Se sobrescribirán los datos actuales.')) return;
                                  try {
                                    const r = await facturasAPI.restaurar(f.id, h.id);
                                    setSelectedFactura(r.data);
                                    loadHistorialFactura(f.id);
                                    setSuccess('Versión restaurada');
                                    setTimeout(() => setSuccess(null), 3000);
                                  } catch (e) {
                                    setError(e.response?.data?.error || 'Error al restaurar');
                                  }
                                }}
                              >
                                Restaurar
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (view === 'form') {
    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>{selectedFactura ? 'Editar factura' : 'Nueva factura'}</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={handleVolver}>← Volver</button>
            <button type="button" className="btn btn-primary" onClick={handleSaveFactura}>Guardar</button>
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <div className="facturacion-content factura-form">
          <div className="form-row">
            <div className="form-group">
              <label>Cliente *</label>
              <select value={form.cliente_id} onChange={(e) => setForm((f) => ({ ...f, cliente_id: e.target.value }))}>
                <option value="">Seleccionar...</option>
                {clientes.map((c) => (
                  <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Serie</label>
              <select value={form.serie} onChange={(e) => setForm((f) => ({ ...f, serie: e.target.value }))}>
                <option value="A">A - General</option>
                <option value="B">B - Simplificada</option>
                <option value="C">C - Recargo de equivalencia</option>
              </select>
            </div>
            {isAdmin && (
              <div className="form-group">
                <label>Nº factura {selectedFactura ? '' : '(vacío = auto)'}</label>
                <input
                  type="text"
                  value={form.numero || ''}
                  onChange={(e) => setForm((f) => ({ ...f, numero: e.target.value }))}
                  placeholder={selectedFactura?.numero || 'Auto-generado'}
                />
              </div>
            )}
            <div className="form-group">
              <label>Fecha emisión</label>
              <input type="date" value={form.fecha_emision} onChange={(e) => setForm((f) => ({ ...f, fecha_emision: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Fecha vencimiento</label>
              <input type="date" value={form.fecha_vencimiento} onChange={(e) => setForm((f) => ({ ...f, fecha_vencimiento: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Retención IRPF %</label>
              <input type="number" step="0.01" min="0" max="100" value={form.retencion_irpf_pct} onChange={(e) => setForm((f) => ({ ...f, retencion_irpf_pct: e.target.value }))} placeholder="0" />
            </div>
          </div>
            <div className="form-group">
              <label>Notas (visibles en PDF para el cliente)</label>
              <textarea value={form.notas} onChange={(e) => setForm((f) => ({ ...f, notas: e.target.value }))} rows={2} placeholder="Notas que aparecerán en el PDF de la factura" />
            </div>
            <div className="form-group">
              <label>Notas internas (solo para ti)</label>
              <textarea value={form.notas_internas} onChange={(e) => setForm((f) => ({ ...f, notas_internas: e.target.value }))} rows={2} placeholder="Notas privadas que no se mostrarán al cliente" />
            </div>
            <div className="form-group">
              <label>Código descuento</label>
              <input
                type="text"
                value={form.codigo_descuento || ''}
                onChange={(e) => setForm((f) => ({ ...f, codigo_descuento: e.target.value }))}
                placeholder="Ej. VERANO20"
                style={{ maxWidth: '200px' }}
              />
            </div>
            <div className="form-group">
              <label>Sesión asociada</label>
              <select
                value={form.consulta_id || ''}
                onChange={(e) => setForm((f) => ({ ...f, consulta_id: e.target.value }))}
              >
                <option value="">Sin sesión asociada</option>
                {consultas
                  .filter(c => !form.cliente_id || String(c.cliente_id) === String(form.cliente_id))
                  .map((c) => {
                    const clienteNom = clientes.find(cl => cl.id === c.cliente_id);
                    const nombre = clienteNom ? `${clienteNom.nombre} ${clienteNom.apellidos}` : '';
                    const fecha = c.fecha_consulta ? new Date(c.fecha_consulta).toLocaleDateString('es-ES') : '';
                    return (
                      <option key={c.id} value={c.id}>
                        Sesión #{c.numero_sesion} - {nombre} - {fecha}
                      </option>
                    );
                  })}
              </select>
              <small style={{ display: 'block', color: '#666', fontSize: '12px', marginTop: '4px' }}>
                {form.cliente_id ? 'Mostrando sesiones del cliente seleccionado' : 'Selecciona un cliente para filtrar sesiones'}
              </small>
            </div>

          <div className="factura-lineas-header">
            <h3>Líneas</h3>
            <div>
              {productos.length > 0 && (
                <select
                  className="select-producto"
                  value=""
                  onChange={(e) => {
                    const id = e.target.value;
                    if (!id) return;
                    const p = productos.find((x) => x.id === Number(id));
                    if (p) addLineaFromProducto(p);
                    e.target.value = '';
                  }}
                >
                  <option value="">Añadir desde catálogo...</option>
                  {productos.map((p) => (
                    <option key={p.id} value={p.id}>{p.nombre} – {Number(p.precio_unitario).toFixed(2)} €</option>
                  ))}
                </select>
              )}
              <button type="button" className="btn btn-secondary btn-sm" onClick={addLinea}>+ Línea</button>
            </div>
          </div>
          <div className="table-wrap">
            <table className="table facturas-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th>Cant.</th>
                  <th>P. unit.</th>
                  <th>Desc. %</th>
                  <th>IVA %</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {form.lineas.map((l, i) => (
                  <tr key={i}>
                    <td>
                      <input type="text" value={l.descripcion} onChange={(e) => updateLinea(i, 'descripcion', e.target.value)} placeholder="Descripción" />
                    </td>
                    <td>
                      <input type="number" step="0.01" min="0" style={{ width: '70px' }} value={l.cantidad} onChange={(e) => updateLinea(i, 'cantidad', e.target.value)} />
                    </td>
                    <td>
                      <input type="number" step="0.01" min="0" style={{ width: '90px' }} value={l.precio_unitario} onChange={(e) => updateLinea(i, 'precio_unitario', e.target.value)} />
                    </td>
                    <td>
                      <input type="number" step="0.01" min="0" max="100" style={{ width: '70px' }} value={l.descuento_pct || 0} onChange={(e) => updateLinea(i, 'descuento_pct', e.target.value)} placeholder="0" />
                    </td>
                    <td>
                      <input type="number" step="0.01" min="0" style={{ width: '60px' }} value={l.iva_pct} onChange={(e) => updateLinea(i, 'iva_pct', e.target.value)} />
                    </td>
                    <td>
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => removeLinea(i)} disabled={form.lineas.length === 1}>×</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="factura-totales">
            {tot.descuento > 0 && (
              <p style={{ color: '#28a745' }}><strong>Descuento total:</strong> -{tot.descuento.toFixed(2)} €</p>
            )}
            <p><strong>Base:</strong> {tot.base.toFixed(2)} €</p>
            <p><strong>IVA:</strong> {tot.iva.toFixed(2)} €</p>
            {tot.retencionIrpf > 0 && (
              <p style={{ color: '#dc3545' }}><strong>Retención IRPF ({form.retencion_irpf_pct}%):</strong> -{tot.retencionIrpf.toFixed(2)} €</p>
            )}
            <p><strong>Total:</strong> {tot.total.toFixed(2)} €</p>
          </div>
        </div>
      </div>
      </>
    );
  }

  if (tab === 'transacciones') {
    const busqueda = filtroTransBusqueda.trim().toLowerCase();
    const transaccionesFiltradas = transacciones.filter((p) => {
      if (!busqueda) return true;
      const factura = String(p.factura_numero || p.factura_id || '').toLowerCase();
      const cliente = `${p.cliente_nombre || ''} ${p.cliente_apellidos || ''}`.trim().toLowerCase();
      const referencia = String(p.referencia || '').toLowerCase();
      const metodo = String(p.metodo || '').toLowerCase();
      return factura.includes(busqueda) || cliente.includes(busqueda) || referencia.includes(busqueda) || metodo.includes(busqueda);
    });

    const exportarTransaccionesCSV = () => {
      const headers = ['Fecha', 'Factura', 'Cliente', 'Importe', 'Tipo', 'Estado', 'Metodo', 'Referencia'];
      const rows = transaccionesFiltradas.map((p) => ([
        p.fecha || '',
        p.factura_numero || `#${p.factura_id}`,
        `${p.cliente_nombre || ''} ${p.cliente_apellidos || ''}`.trim(),
        Number(p.importe || 0).toFixed(2),
        p.tipo_movimiento || 'cobro',
        p.estado || 'confirmado',
        p.metodo || '',
        p.referencia || '',
      ]));
      const csv = [headers, ...rows].map((r) => r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n');
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `transacciones_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    };

    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>Transacciones</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>
              Facturas
            </button>
            <button type="button" className="btn btn-secondary" onClick={loadTransacciones}>
              Recargar
            </button>
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div className="facturacion-filters">
          <div className="filters-row">
            <input
              type="text"
              placeholder="Buscar por factura, cliente, referencia o método..."
              value={filtroTransBusqueda}
              onChange={(e) => setFiltroTransBusqueda(e.target.value)}
              style={{ flex: 1, minWidth: '320px' }}
            />
            <select value={filtroTransEstado} onChange={(e) => setFiltroTransEstado(e.target.value)}>
              <option value="">Todos los estados</option>
              <option value="confirmado">confirmado</option>
              <option value="cancelado">cancelado</option>
            </select>
            <select value={filtroTransCliente} onChange={(e) => setFiltroTransCliente(e.target.value)}>
              <option value="">Todos los clientes</option>
              {clientes.map((c) => (
                <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
              ))}
            </select>
            <input type="date" value={filtroTransFechaDesde} onChange={(e) => setFiltroTransFechaDesde(e.target.value)} />
            <input type="date" value={filtroTransFechaHasta} onChange={(e) => setFiltroTransFechaHasta(e.target.value)} />
            <button type="button" className="btn btn-secondary btn-sm" onClick={loadTransacciones}>Aplicar filtros</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={limpiarFiltrosTransacciones}>Limpiar</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={exportarTransaccionesCSV} disabled={transaccionesFiltradas.length === 0}>Exportar CSV</button>
          </div>
        </div>

        <div className="stats-grid" style={{ marginBottom: '20px' }}>
          <div className="stat-card stat-success">
            <h3>Cobrado hoy</h3>
            <p className="stat-value">{Number(kpisCobros.cobrado_hoy || 0).toFixed(2)} €</p>
          </div>
          <div className="stat-card stat-info">
            <h3>Cobrado mes</h3>
            <p className="stat-value">{Number(kpisCobros.cobrado_mes || 0).toFixed(2)} €</p>
          </div>
          <div className="stat-card stat-primary">
            <h3>Tasa éxito cobro</h3>
            <p className="stat-value">{Number(kpisCobros.tasa_exito_cobro || 0).toFixed(2)}%</p>
          </div>
        </div>

        <div className="facturacion-content">
          {loading ? (
            <p className="loading">Cargando transacciones...</p>
          ) : (
            <div className="table-wrap">
              <table className="table facturas-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Factura</th>
                    <th>Cliente</th>
                    <th>Importe</th>
                    <th>Tipo</th>
                    <th>Estado</th>
                    <th>Método</th>
                    <th>Referencia</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {transaccionesFiltradas.map((p) => (
                    <tr key={p.id}>
                      <td>{p.fecha ? new Date(p.fecha).toLocaleDateString('es-ES') : '-'}</td>
                      <td>{p.factura_numero || ('#' + p.factura_id)}</td>
                      <td>{`${p.cliente_nombre || ''} ${p.cliente_apellidos || ''}`.trim() || ('#' + p.cliente_id)}</td>
                      <td>{Number(p.importe || 0).toFixed(2)} €</td>
                      <td>{p.tipo_movimiento || 'cobro'}</td>
                      <td><span className={`estado-badge estado-${(p.estado || 'confirmado').replace(/\s+/g, '-')}`}>{p.estado || 'confirmado'}</span></td>
                      <td>{p.metodo || '-'}</td>
                      <td>{p.referencia || '-'}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-edit btn-sm"
                          onClick={() => {
                            setTab('facturas');
                            handleVerFactura({ id: p.factura_id });
                          }}
                        >
                          Ver factura
                        </button>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleDescargarRecibo(p.id)}>Recibo</button>
                        <button type="button" className="btn btn-secondary btn-sm" style={{ marginLeft: '4px' }} onClick={() => handleEnviarReciboEmail(p.id)}>Email</button>
                      </td>
                    </tr>
                  ))}
                  {transaccionesFiltradas.length === 0 && (
                    <tr>
                      <td colSpan="9" style={{ textAlign: 'center', color: '#666' }}>No hay transacciones con los filtros actuales.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          <p className="facturacion-hint" style={{ marginTop: '8px' }}>
            Mostrando {transaccionesFiltradas.length} de {transacciones.length} transacciones.
          </p>
        </div>
      </div>
      </>
    );
  }

  // Renderizar Dashboard
  if (tab === 'dashboard') {
    return (
      <>
        {emailModal}
      <div className="facturacion">
        <div className="page-header">
          <h2>Dashboard de Facturación</h2>
          <div className="facturacion-actions">
            <button type="button" className="btn btn-secondary" onClick={() => setTab('facturas')}>
              Facturas
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setTab('transacciones')}>
              Transacciones
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setTab('presupuestos')}>
              Presupuestos
            </button>
            <button type="button" className="btn btn-secondary" onClick={() => setTab('productos')}>
              Productos
            </button>
          </div>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <div className="facturacion-content">
          {statsLoading ? (
            <p className="loading">Cargando estadísticas...</p>
          ) : stats ? (
            <div className="dashboard-facturacion">
              {/* Alertas y Recordatorios */}
              {recordatorios && recordatorios.total_alertas > 0 && (
                <div className="dashboard-section alertas-section" style={{ marginBottom: '30px', background: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '8px', padding: '20px' }}>
                  <h3 style={{ color: '#856404', marginBottom: '15px' }}>⚠️ Recordatorios</h3>
                  
                  {recordatorios.facturas_vencidas.length > 0 && (
                    <div style={{ marginBottom: '15px' }}>
                      <h4 style={{ color: '#dc3545', fontSize: '16px', marginBottom: '10px' }}>Facturas Vencidas ({recordatorios.facturas_vencidas.length})</h4>
                      <div style={{ display: 'grid', gap: '8px' }}>
                        {recordatorios.facturas_vencidas.map((f) => (
                          <div key={f.id} style={{ padding: '8px 12px', background: '#f8d7da', borderRadius: '4px', fontSize: '14px' }}>
                            <strong>Factura {f.numero}</strong> - {f.cliente_nombre} {f.cliente_apellidos} - {Number(f.total).toFixed(2)}€ - 
                            <span style={{ fontWeight: 'bold', color: '#721c24' }}> Vencida hace {f.dias_vencida} día{f.dias_vencida > 1 ? 's' : ''}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {recordatorios.facturas_proximas_vencer.length > 0 && (
                    <div style={{ marginBottom: '15px' }}>
                      <h4 style={{ color: '#fd7e14', fontSize: '16px', marginBottom: '10px' }}>Facturas Próximas a Vencer ({recordatorios.facturas_proximas_vencer.length})</h4>
                      <div style={{ display: 'grid', gap: '8px' }}>
                        {recordatorios.facturas_proximas_vencer.map((f) => (
                          <div key={f.id} style={{ padding: '8px 12px', background: '#fff3cd', borderRadius: '4px', fontSize: '14px' }}>
                            <strong>Factura {f.numero}</strong> - {f.cliente_nombre} {f.cliente_apellidos} - {Number(f.total).toFixed(2)}€ - 
                            <span style={{ fontWeight: 'bold', color: '#856404' }}> Vence en {f.dias_para_vencer} día{f.dias_para_vencer > 1 ? 's' : ''}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {recordatorios.presupuestos_expirados.length > 0 && (
                    <div>
                      <h4 style={{ color: '#6c757d', fontSize: '16px', marginBottom: '10px' }}>Presupuestos Expirados ({recordatorios.presupuestos_expirados.length})</h4>
                      <div style={{ display: 'grid', gap: '8px' }}>
                        {recordatorios.presupuestos_expirados.map((p) => (
                          <div key={p.id} style={{ padding: '8px 12px', background: '#e2e3e5', borderRadius: '4px', fontSize: '14px' }}>
                            <strong>Presupuesto {p.numero}</strong> - {p.cliente_nombre} {p.cliente_apellidos} - {Number(p.total).toFixed(2)}€ - 
                            <span style={{ fontWeight: 'bold', color: '#6c757d' }}> Expirado hace {p.dias_expirado} día{p.dias_expirado > 1 ? 's' : ''}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Tarjetas principales */}
              <div className="stats-grid">
                <div className="stat-card stat-primary">
                  <h3>Total Facturado</h3>
                  <p className="stat-value">{Number(stats.total_facturado || 0).toFixed(2)} €</p>
                  <p className="stat-label">Todas las facturas pagadas</p>
                </div>
                <div className="stat-card stat-success">
                  <h3>Este Mes</h3>
                  <p className="stat-value">{Number(stats.facturado_mes_actual || 0).toFixed(2)} €</p>
                  <p className="stat-label">Facturado en {new Date().toLocaleString('es-ES', { month: 'long', year: 'numeric' })}</p>
                </div>
                <div className="stat-card stat-info">
                  <h3>Este Año</h3>
                  <p className="stat-value">{Number(stats.facturado_ano_actual || 0).toFixed(2)} €</p>
                  <p className="stat-label">Facturado en {new Date().getFullYear()}</p>
                </div>
                <div className="stat-card stat-warning">
                  <h3>Pendiente</h3>
                  <p className="stat-value">{Number(stats.total_pendiente || 0).toFixed(2)} €</p>
                  <p className="stat-label">{stats.facturas_pendientes || 0} facturas pendientes</p>
                </div>
                <div className="stat-card stat-danger">
                  <h3>Vencidas</h3>
                  <p className="stat-value">{Number(stats.total_vencido || 0).toFixed(2)} €</p>
                  <p className="stat-label">{stats.facturas_vencidas || 0} facturas vencidas</p>
                </div>
                <div className="stat-card stat-secondary">
                  <h3>Total Pagado</h3>
                  <p className="stat-value">{Number(stats.total_pagado || 0).toFixed(2)} €</p>
                  <p className="stat-label">Suma de todos los pagos</p>
                </div>
                <div className="stat-card stat-primary">
                  <h3>Cobrado Hoy</h3>
                  <p className="stat-value">{Number(stats.cobrado_hoy || 0).toFixed(2)} €</p>
                  <p className="stat-label">Cobros confirmados de hoy</p>
                </div>
                <div className="stat-card stat-info">
                  <h3>Tasa Éxito Cobro</h3>
                  <p className="stat-value">{Number(stats.tasa_exito_cobro || 0).toFixed(2)}%</p>
                  <p className="stat-label">Intentos confirmados</p>
                </div>
              </div>

              {/* Facturas por estado */}
              <div className="dashboard-section">
                <h3>Facturas por Estado</h3>
                <div className="table-wrap">
                  <table className="table facturas-table">
                    <thead>
                      <tr>
                        <th>Estado</th>
                        <th>Cantidad</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(stats.facturas_por_estado || {}).map(([estado, data]) => (
                        <tr key={estado}>
                          <td><span className={`estado-badge estado-${estado}`}>{estado}</span></td>
                          <td>{data.count}</td>
                          <td>{Number(data.total).toFixed(2)} €</td>
                        </tr>
                      ))}
                      {Object.keys(stats.facturas_por_estado || {}).length === 0 && (
                        <tr>
                          <td colSpan="3" style={{ textAlign: 'center', color: '#666' }}>No hay facturas</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Presupuestos */}
              <div className="dashboard-section">
                <h3>Presupuestos</h3>
                <div className="stats-grid-small">
                  <div className="stat-card-small">
                    <h4>Total Presupuestos</h4>
                    <p className="stat-value-small">{stats.total_presupuestos || 0}</p>
                  </div>
                  <div className="stat-card-small">
                    <h4>Pendientes</h4>
                    <p className="stat-value-small">{stats.presupuestos_pendientes || 0}</p>
                    <p className="stat-label-small">{Number(stats.total_presupuestos_pendientes || 0).toFixed(2)} €</p>
                  </div>
                </div>
                {Object.keys(stats.presupuestos_por_estado || {}).length > 0 && (
                  <div className="table-wrap" style={{ marginTop: '16px' }}>
                    <table className="table facturas-table">
                      <thead>
                        <tr>
                          <th>Estado</th>
                          <th>Cantidad</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(stats.presupuestos_por_estado || {}).map(([estado, data]) => (
                          <tr key={estado}>
                            <td><span className={`estado-badge estado-${estado}`}>{estado}</span></td>
                            <td>{data.count}</td>
                            <td>{Number(data.total).toFixed(2)} €</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Suscripciones (solo admin) */}
              {user?.rol === 'admin' && (() => {
                const IVA_PCT = 21;
                const conIva = (importe) => Number(importe || 0) * (1 + IVA_PCT / 100);
                const pagados = subsPayments.filter(p => p.estado === 'pagado');
                const pendientes = subsPayments.filter(p => p.estado === 'pendiente');
                const vencidos = subsPayments.filter(p => p.estado === 'vencido');
                const totalCobrado = pagados.reduce((s, p) => s + conIva(p.importe), 0);
                const totalPendiente = pendientes.reduce((s, p) => s + conIva(p.importe), 0);
                const totalVencido = vencidos.reduce((s, p) => s + conIva(p.importe), 0);
                const now = new Date();
                const mesActual = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
                const cobradoMes = pagados.filter(p => (p.fecha_pago || '').startsWith(mesActual)).reduce((s, p) => s + conIva(p.importe), 0);
                const anoActual = String(now.getFullYear());
                const cobradoAno = pagados.filter(p => (p.fecha_pago || '').startsWith(anoActual)).reduce((s, p) => s + conIva(p.importe), 0);

                const porMes = {};
                pagados.forEach(p => {
                  const m = (p.fecha_pago || '').slice(0, 7);
                  if (m) porMes[m] = (porMes[m] || 0) + conIva(p.importe);
                });
                const meses12 = [];
                for (let i = 11; i >= 0; i--) {
                  const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
                  const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                  meses12.push({ mes: key, total: porMes[key] || 0 });
                }

                // Alerta: pagos que vencen en los próximos 7 días
                const en7dias = new Date();
                en7dias.setDate(en7dias.getDate() + 7);
                const hoyStr = now.toISOString().slice(0, 10);
                const en7diasStr = en7dias.toISOString().slice(0, 10);
                const proximosAVencer = subsPayments.filter(p =>
                  p.estado === 'pendiente' &&
                  p.fecha_vencimiento >= hoyStr &&
                  p.fecha_vencimiento <= en7diasStr
                );

                // Usuarios únicos para filtro
                const usuariosUnicos = [...new Map(subsPayments.map(p => [p.usuario_id, { id: p.usuario_id, nombre: `${p.usuario_nombre || ''} ${p.usuario_apellidos || ''}`.trim() }])).values()].sort((a, b) => a.nombre.localeCompare(b.nombre));

                // Filtrar pagos
                let pagosFiltrados = subsPayments.slice();
                if (subsFilterEstado !== 'todos') {
                  pagosFiltrados = pagosFiltrados.filter(p => p.estado === subsFilterEstado);
                }
                if (subsFilterUsuario !== 'todos') {
                  pagosFiltrados = pagosFiltrados.filter(p => String(p.usuario_id) === subsFilterUsuario);
                }
                if (subsFilterFactura === 'con') {
                  pagosFiltrados = pagosFiltrados.filter(p => p.factura_numero || p.factura_archivo);
                } else if (subsFilterFactura === 'sin') {
                  pagosFiltrados = pagosFiltrados.filter(p => !p.factura_numero && !p.factura_archivo);
                }
                pagosFiltrados.sort((a, b) => (b.fecha_vencimiento || '').localeCompare(a.fecha_vencimiento || ''));

                // Exportar CSV
                const exportarCSV = () => {
                  const headers = ['ID', 'Usuario', 'Plan', 'Base', 'IVA %', 'Total (IVA incl.)', 'Moneda', 'Vencimiento', 'Estado', 'Factura Nº', 'Método Pago', 'Fecha Pago'];
                  const rows = pagosFiltrados.map(p => [
                    p.id,
                    `${p.usuario_nombre || ''} ${p.usuario_apellidos || ''}`.trim(),
                    p.plan_nombre || '',
                    Number(p.importe || 0).toFixed(2),
                    IVA_PCT,
                    conIva(p.importe).toFixed(2),
                    p.moneda || 'EUR',
                    p.fecha_vencimiento || '',
                    p.estado || '',
                    p.factura_numero || '',
                    p.metodo_pago || '',
                    p.fecha_pago || ''
                  ]);
                  const csvContent = [headers, ...rows].map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
                  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `pagos_suscripciones_${new Date().toISOString().slice(0, 10)}.csv`;
                  a.click();
                  URL.revokeObjectURL(url);
                };

                // Acción rápida: marcar como pagado
                const handleMarcarPagadoRapido = async (pagoId) => {
                  const metodo = prompt('Método de pago (transferencia, tarjeta, paypal, bizum):', 'transferencia');
                  if (!metodo) return;
                  try {
                    await pagosUsuariosAPI.marcarPagado(pagoId, { metodo_pago: metodo });
                    loadSubsPayments();
                  } catch (err) {
                    alert(err.response?.data?.error || 'Error al marcar como pagado');
                  }
                };

                // Acción rápida: crear factura
                const handleCrearFacturaRapido = async (pagoId) => {
                  const numero = prompt('Número de factura:', '');
                  if (!numero) return;
                  try {
                    await pagosUsuariosAPI.generarFactura(pagoId, numero);
                    loadSubsPayments();
                  } catch (err) {
                    alert(err.response?.data?.error || 'Error al generar factura');
                  }
                };

                const waEnabled = user?.rol === 'admin' || user?.whatsapp_habilitado === true || user?.whatsapp_habilitado === 1;
                const buildWhatsAppUrl = (phone, text) => {
                  const cleanPhone = (phone || '').replace(/[^0-9]/g, '');
                  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(text)}`;
                };
                const handleSubsEmailSend = async () => {
                  if (!subsEmailForm.email || !subsEmailForm.email.includes('@')) {
                    alert('Email válido requerido');
                    return;
                  }
                  try {
                    setSubsEmailSending(true);
                    const response = await emailAPI.send('factura_suscripcion', subsEmailPagoId, subsEmailForm.email, subsEmailForm.mensaje);
                    if (response.data?.success) {
                      setShowSubsEmailModal(false);
                      setSubsEmailForm({ email: '', mensaje: '' });
                      alert('Email enviado correctamente');
                    } else {
                      alert(response.data?.error || 'Error al enviar email');
                    }
                  } catch (e) {
                    alert(e.response?.data?.error || 'Error al enviar email');
                  } finally {
                    setSubsEmailSending(false);
                  }
                };

                const handleWhatsAppPago = (p) => {
                  const telefono = p.usuario_telefono || '';
                  if (!telefono) {
                    alert('Este usuario no tiene teléfono registrado');
                    return;
                  }
                  const nombre = `${p.usuario_nombre || ''} ${p.usuario_apellidos || ''}`.trim();
                  let texto = `Hola ${nombre}, te envío la información de tu pago de suscripción (${p.plan_nombre || 'plan'}) por ${conIva(p.importe).toFixed(2)} € (IVA incl.) con vencimiento ${p.fecha_vencimiento || ''}.`;
                  if (p.factura_archivo) {
                    texto += `\n\nPuedes ver tu factura aquí: ${window.location.origin}${getSecureFileUrl(p.factura_archivo)}`;
                  }
                  window.open(buildWhatsAppUrl(telefono, texto), '_blank');
                };

                return (
                  <div className="dashboard-section" style={{ marginTop: '30px' }}>
                    <h3>Suscripciones - Pagos de Usuarios</h3>

                    {/* Alerta de pagos próximos a vencer */}
                    {proximosAVencer.length > 0 && (
                      <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '6px', padding: '12px 16px', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '20px' }}>&#9888;</span>
                        <div>
                          <strong>{proximosAVencer.length} pago{proximosAVencer.length > 1 ? 's' : ''} vence{proximosAVencer.length > 1 ? 'n' : ''} en los próximos 7 días</strong>
                          <div style={{ fontSize: '13px', color: '#856404', marginTop: '4px' }}>
                            {proximosAVencer.slice(0, 5).map(p => (
                              <span key={p.id} style={{ marginRight: '12px' }}>
                                {p.usuario_nombre} {p.usuario_apellidos} - {conIva(p.importe).toFixed(2)} € ({p.fecha_vencimiento})
                              </span>
                            ))}
                            {proximosAVencer.length > 5 && <span>y {proximosAVencer.length - 5} más...</span>}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="stats-grid">
                      <div className="stat-card stat-primary">
                        <h3>Total Cobrado</h3>
                        <p className="stat-value">{totalCobrado.toFixed(2)} €</p>
                        <p className="stat-label">{pagados.length} pagos cobrados</p>
                      </div>
                      <div className="stat-card stat-success">
                        <h3>Este Mes</h3>
                        <p className="stat-value">{cobradoMes.toFixed(2)} €</p>
                        <p className="stat-label">Cobrado en {now.toLocaleString('es-ES', { month: 'long', year: 'numeric' })}</p>
                      </div>
                      <div className="stat-card stat-info">
                        <h3>Este Año</h3>
                        <p className="stat-value">{cobradoAno.toFixed(2)} €</p>
                        <p className="stat-label">Cobrado en {now.getFullYear()}</p>
                      </div>
                      <div className="stat-card stat-warning">
                        <h3>Pendiente</h3>
                        <p className="stat-value">{totalPendiente.toFixed(2)} €</p>
                        <p className="stat-label">{pendientes.length} pagos pendientes</p>
                      </div>
                      <div className="stat-card stat-danger">
                        <h3>Vencidos</h3>
                        <p className="stat-value">{vencidos.length}</p>
                        <p className="stat-label">{totalVencido.toFixed(2)} € vencidos</p>
                      </div>
                    </div>

                    {/* Ingresos suscripciones por mes */}
                    {meses12.some(m => m.total > 0) && (
                      <>
                        <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>Ingresos Suscripciones por Mes</h4>
                        <div className="chart-container">
                          <div className="chart-bars">
                            {meses12.map((item) => {
                              const maxVal = Math.max(...meses12.map(i => i.total));
                              const height = maxVal > 0 ? (item.total / maxVal) * 100 : 0;
                              const [a, m] = item.mes.split('-');
                              const f = new Date(a, m - 1, 1);
                              return (
                                <div key={item.mes} className="chart-bar-item">
                                  <div className="chart-bar-wrapper">
                                    <div className="chart-bar" style={{ height: `${height}%`, background: '#17a2b8' }} title={`${item.total.toFixed(2)} €`} />
                                  </div>
                                  <div className="chart-label">{f.toLocaleString('es-ES', { month: 'short' })}</div>
                                  <div className="chart-value">{item.total.toFixed(0)}€</div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Filtros y exportar */}
                    <div style={{ marginTop: '20px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                      <h4 style={{ margin: 0 }}>Pagos de Suscripciones</h4>
                      <select
                        value={subsFilterEstado}
                        onChange={e => setSubsFilterEstado(e.target.value)}
                        style={{ padding: '5px 10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                      >
                        <option value="todos">Todos los estados</option>
                        <option value="pendiente">Pendiente</option>
                        <option value="pagado">Pagado</option>
                        <option value="vencido">Vencido</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                      <select
                        value={subsFilterUsuario}
                        onChange={e => setSubsFilterUsuario(e.target.value)}
                        style={{ padding: '5px 10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                      >
                        <option value="todos">Todos los usuarios</option>
                        {usuariosUnicos.map(u => (
                          <option key={u.id} value={String(u.id)}>{u.nombre}</option>
                        ))}
                      </select>
                      <select
                        value={subsFilterFactura}
                        onChange={e => setSubsFilterFactura(e.target.value)}
                        style={{ padding: '5px 10px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                      >
                        <option value="todos">Todas las facturas</option>
                        <option value="con">Con factura</option>
                        <option value="sin">Sin factura</option>
                      </select>
                      <button
                        onClick={exportarCSV}
                        style={{ padding: '5px 12px', borderRadius: '4px', border: '1px solid #28a745', background: '#28a745', color: '#fff', cursor: 'pointer', fontSize: '13px' }}
                        title="Exportar datos filtrados a CSV"
                      >
                        Exportar CSV
                      </button>
                      <span style={{ fontSize: '12px', color: '#666' }}>
                        {pagosFiltrados.length} de {subsPayments.length} pagos
                      </span>
                    </div>

                    <div className="table-wrap">
                      <table className="table facturas-table">
                        <thead>
                          <tr>
                            <th>Usuario</th>
                            <th>Plan</th>
                            <th>Importe (IVA incl.)</th>
                            <th>Vencimiento</th>
                            <th>Estado</th>
                            <th>Factura</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagosFiltrados.map(p => {
                            const estadoMap = { pagado: 'Pagado', pendiente: 'Pendiente', vencido: 'Vencido', cancelado: 'Cancelado' };
                            const badgeClass = p.estado === 'pagado' ? 'pagada' : p.estado === 'pendiente' ? 'pendiente' : p.estado === 'vencido' ? 'vencida' : p.estado;
                            return (
                              <tr key={p.id}>
                                <td>{p.usuario_nombre} {p.usuario_apellidos}</td>
                                <td>{p.plan_nombre || '-'}</td>
                                <td title={`Base: ${Number(p.importe || 0).toFixed(2)} € + ${IVA_PCT}% IVA`}>{conIva(p.importe).toFixed(2)} €</td>
                                <td>{p.fecha_vencimiento || '-'}</td>
                                <td>
                                  <span className={`estado-badge estado-${badgeClass}`}>
                                    {estadoMap[p.estado] || p.estado || '-'}
                                  </span>
                                </td>
                                <td>
                                  {p.factura_numero ? (
                                    <span>{p.factura_numero}</span>
                                  ) : (
                                    <span style={{ color: '#999' }}>-</span>
                                  )}
                                </td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                  {(p.estado === 'pendiente' || p.estado === 'vencido') && (
                                    <button
                                      className="btn btn-success btn-sm"
                                      style={{ fontSize: '11px', padding: '3px 8px', marginRight: '4px' }}
                                      onClick={() => handleMarcarPagadoRapido(p.id)}
                                      title="Marcar como pagado"
                                    >
                                      Cobrar
                                    </button>
                                  )}
                                  {!p.factura_numero && (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      style={{ fontSize: '11px', padding: '3px 8px', marginRight: '4px' }}
                                      onClick={() => handleCrearFacturaRapido(p.id)}
                                      title="Crear factura"
                                    >
                                      Facturar
                                    </button>
                                  )}
                                  {p.factura_archivo && (
                                    <>
                                      <button
                                        className="btn btn-secondary btn-sm"
                                        style={{ fontSize: '11px', padding: '3px 8px', marginRight: '4px' }}
                                        onClick={() => window.open(getSecureFileUrl(p.factura_archivo), '_blank')}
                                        title="Ver factura"
                                      >
                                        Ver
                                      </button>
                                      <button
                                        className="btn btn-info btn-sm"
                                        style={{ fontSize: '11px', padding: '3px 8px', marginRight: '4px' }}
                                        onClick={() => {
                                          setSubsEmailPagoId(p.id);
                                          setSubsEmailForm({ email: p.usuario_email || '', mensaje: '' });
                                          setShowSubsEmailModal(true);
                                        }}
                                        title="Enviar por email"
                                      >
                                        Email
                                      </button>
                                    </>
                                  )}
                                  {waEnabled && (
                                    <button
                                      className="btn btn-sm"
                                      style={{ fontSize: '11px', padding: '3px 8px', background: '#25D366', color: '#fff', border: 'none' }}
                                      onClick={() => handleWhatsAppPago(p)}
                                      title="Enviar por WhatsApp"
                                    >
                                      WA
                                    </button>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                          {pagosFiltrados.length === 0 && (
                            <tr>
                              <td colSpan="7" style={{ textAlign: 'center', color: '#666' }}>
                                {subsPayments.length === 0 ? 'No hay pagos de suscripciones' : 'No hay pagos con los filtros seleccionados'}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {showSubsEmailModal && (
                      <div className="modal-overlay" onClick={() => setShowSubsEmailModal(false)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                          <h3>Enviar Factura de Suscripción por Email</h3>
                          <div className="form-group">
                            <label>Email del destinatario *</label>
                            <input
                              type="email"
                              value={subsEmailForm.email}
                              onChange={(e) => setSubsEmailForm(f => ({ ...f, email: e.target.value }))}
                              placeholder="usuario@email.com"
                              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                          </div>
                          <div className="form-group">
                            <label>Mensaje personalizado (opcional)</label>
                            <textarea
                              value={subsEmailForm.mensaje}
                              onChange={(e) => setSubsEmailForm(f => ({ ...f, mensaje: e.target.value }))}
                              rows={4}
                              placeholder="Mensaje adicional..."
                              style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                            />
                          </div>
                          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
                            <button className="btn btn-secondary" onClick={() => { setShowSubsEmailModal(false); setSubsEmailForm({ email: '', mensaje: '' }); }}>
                              Cancelar
                            </button>
                            <button className="btn btn-primary" onClick={handleSubsEmailSend} disabled={subsEmailSending}>
                              {subsEmailSending ? 'Enviando...' : 'Enviar Email'}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Ingresos por mes */}
              {stats.ingresos_por_mes && stats.ingresos_por_mes.length > 0 && (
                <div className="dashboard-section">
                  <h3>Ingresos por Mes (Últimos 12 meses)</h3>
                  {/* Gráfico de barras */}
                  <div className="chart-container">
                    <div className="chart-bars">
                      {stats.ingresos_por_mes.map((item) => {
                        const maxValue = Math.max(...stats.ingresos_por_mes.map(i => i.total));
                        const height = maxValue > 0 ? (item.total / maxValue) * 100 : 0;
                        const [ano, mes] = item.mes.split('-');
                        const fecha = new Date(ano, mes - 1, 1);
                        return (
                          <div key={item.mes} className="chart-bar-item">
                            <div className="chart-bar-wrapper">
                              <div 
                                className="chart-bar" 
                                style={{ height: `${height}%` }}
                                title={`${Number(item.total).toFixed(2)} €`}
                              />
                            </div>
                            <div className="chart-label">{fecha.toLocaleString('es-ES', { month: 'short' })}</div>
                            <div className="chart-value">{Number(item.total).toFixed(0)}€</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="table-wrap" style={{ marginTop: '20px' }}>
                    <table className="table facturas-table">
                      <thead>
                        <tr>
                          <th>Mes</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stats.ingresos_por_mes.map((item) => {
                          const [ano, mes] = item.mes.split('-');
                          const fecha = new Date(ano, mes - 1, 1);
                          return (
                            <tr key={item.mes}>
                              <td>{fecha.toLocaleString('es-ES', { month: 'long', year: 'numeric' })}</td>
                              <td><strong>{Number(item.total).toFixed(2)} €</strong></td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p className="empty-state">No se pudieron cargar las estadísticas.</p>
          )}
        </div>
      </div>
      </>
    );
  }

  return (
    <>
      {emailModal}
    <div className="facturacion">
      <div className="page-header">
        <h2>Facturación</h2>
        <div className="facturacion-actions">
          <button type="button" className={`btn ${tab === 'dashboard' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('dashboard')}>
            Dashboard
          </button>
          <button type="button" className={`btn ${tab === 'presupuestos' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('presupuestos')}>
            Presupuestos
          </button>
          <button type="button" className={`btn ${tab === 'transacciones' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('transacciones')}>
            Transacciones
          </button>
          <div className="facturacion-more-menu">
            <button type="button" className="btn btn-secondary">
              Mas secciones ▾
            </button>
            <div className="facturacion-more-panel">
              <button type="button" className={`btn ${tab === 'recurrentes' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('recurrentes')}>
                Facturas recurrentes
              </button>
              <button type="button" className={`btn ${tab === 'productos' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('productos')}>
                Productos y servicios
              </button>
              <button type="button" className={`btn ${tab === 'tipos_impositivos' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('tipos_impositivos')}>
                Tipos impositivos
              </button>
              <button type="button" className={`btn ${tab === 'promociones' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTab('promociones')}>
                Promociones
              </button>
            </div>
          </div>
          <button type="button" className="btn btn-success" onClick={handleOpenQuickInvoice}>
            Factura rápida
          </button>
          <button type="button" className="btn btn-primary" onClick={handleNuevaFactura}>
            Nueva factura
          </button>
        </div>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      {quickInvoiceModal}

      <div className="facturacion-filters">
        <div className="filters-row">
          <input
            type="text"
            placeholder="Buscar por número o cliente..."
            value={filtroBusqueda}
            onChange={(e) => setFiltroBusqueda(e.target.value)}
            style={{ flex: 1, maxWidth: '300px', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            {ESTADOS.map((e) => (
              <option key={e} value={e}>{e}</option>
            ))}
          </select>
          <select value={filtroCliente} onChange={(e) => setFiltroCliente(e.target.value)}>
            <option value="">Todos los clientes</option>
            {clientes.map((c) => (
              <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
            ))}
          </select>
          <input
            type="date"
            placeholder="Desde"
            value={filtroFechaDesde}
            onChange={(e) => setFiltroFechaDesde(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <input
            type="date"
            placeholder="Hasta"
            value={filtroFechaHasta}
            onChange={(e) => setFiltroFechaHasta(e.target.value)}
            style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <button type="button" className="btn btn-secondary btn-sm" onClick={exportarFacturasCSV}>
            📥 Exportar CSV
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            disabled={facturasSeleccionadas.size === 0}
            onClick={() => {
              if (facturasSeleccionadas.size > 0) {
                facturasAPI.downloadZip(Array.from(facturasSeleccionadas));
                setSuccess(`${facturasSeleccionadas.size} factura(s) descargando en ZIP`);
                setTimeout(() => setSuccess(null), 3000);
              }
            }}
          >
            📦 Descargar selección en ZIP
          </button>
        </div>
      </div>

      <div className="facturacion-content">
        {loading ? (
          <p className="loading">Cargando facturas...</p>
        ) : (
          <>
            <div className="table-wrap">
              <table className="table facturas-table">
                <thead>
                  <tr>
                    <th style={{ width: '40px' }}>
                      <input
                        type="checkbox"
                        title={facturas.length > 0 && facturas.every((f) => facturasSeleccionadas.has(f.id)) ? 'Quitar todas' : 'Seleccionar todas'}
                        checked={facturas.length > 0 && facturas.every((f) => facturasSeleccionadas.has(f.id))}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFacturasSeleccionadas(new Set(facturas.map((f) => f.id)));
                          } else {
                            setFacturasSeleccionadas(new Set());
                          }
                        }}
                      />
                    </th>
                    <th>Número</th>
                    <th>Cliente</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Total</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {facturas.map((f) => (
                    <tr key={f.id} id={`factura-${f.id}`}>
                      <td>
                        <input
                          type="checkbox"
                          checked={facturasSeleccionadas.has(f.id)}
                          onChange={() => {
                            setFacturasSeleccionadas((prev) => {
                              const next = new Set(prev);
                              if (next.has(f.id)) next.delete(f.id);
                              else next.add(f.id);
                              return next;
                            });
                          }}
                        />
                      </td>
                      <td>{f.numero}</td>
                      <td>{getClienteNombre(f.cliente_id) || (f.cliente_nombre + ' ' + (f.cliente_apellidos || ''))}</td>
                      <td>{f.fecha_emision ? new Date(f.fecha_emision).toLocaleDateString('es-ES') : '-'}</td>
                      <td><span className={`estado-badge estado-${f.estado}`}>{f.estado}</span></td>
                      <td>{Number(f.total).toFixed(2)} €</td>
                      <td>
                        <button type="button" className="btn btn-edit btn-sm" onClick={() => handleVerFactura(f)}>Ver</button>
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          style={{ marginLeft: '4px' }}
                          onClick={async () => {
                            try {
                              const r = await facturasAPI.duplicate(f.id);
                              setSuccess('Factura duplicada');
                              setSelectedFactura(r.data);
                              setView('detail');
                              loadFacturas();
                              setTimeout(() => setSuccess(null), 3000);
                            } catch (e) {
                              setError(e.response?.data?.error || 'Error al duplicar');
                            }
                          }}
                        >
                          Duplicar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {facturas.length === 0 && (
              <p className="empty-state">No hay facturas. Crea la primera con &quot;Nueva factura&quot;.</p>
            )}
          </>
        )}
      </div>
      </div>
      </>
    );
}

export default Facturacion;
